
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire37b7"];
var parcelRegister = parcelRequire.register;
parcelRegister("5v178", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4010b6391fd55cd8$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $2yRMe = parcelRequire("2yRMe");

var $hTumZ = parcelRequire("hTumZ");

var $cS1ZL = parcelRequire("cS1ZL");
var $gMobs = parcelRequire("gMobs");


var $7xwGT = parcelRequire("7xwGT");
var $4010b6391fd55cd8$var$rootStyles = null;
var $4010b6391fd55cd8$var$iconColor = {
    connectivity: "_x5v91r2e",
    confirmation: "_x5v91fgg",
    info: "_x5v913wx",
    warning: "_x5v9f6ss",
    error: "_x5v9k8x7"
};
/**
 * __Inline message__
 *
 * An inline message lets users know when important information is available or when an action is required.
 *
 * - [Examples](https://atlassian.design/components/inline-message/examples)
 * - [Code](https://atlassian.design/components/inline-message/code)
 * - [Usage](https://atlassian.design/components/inline-message/usage)
 *
 * @example
 *
 * ```jsx
 * const Component = () => (
 *   <InlineMessage
 *    title="Inline Message Title Example"
 *    secondaryText="Secondary Text"
 *   >
 *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
 *   </InlineMessage>
 * );
 * ```
 */ var $4010b6391fd55cd8$var$InlineMessage = function InlineMessage(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$secondaryText = _ref.secondaryText, secondaryText = _ref$secondaryText === void 0 ? "" : _ref$secondaryText, _ref$title = _ref.title, title = _ref$title === void 0 ? "" : _ref$title, _ref$type = _ref.type, type = _ref$type === void 0 ? "connectivity" : _ref$type, appearance = _ref.appearance, children = _ref.children, testId = _ref.testId, iconLabel = _ref.iconLabel;
    var _useState = (0, $91i6m.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), isOpen = _useState2[0], setIsOpen = _useState2[1];
    var toggleDialog = (0, $91i6m.useCallback)(function() {
        setIsOpen(function(oldState) {
            return !oldState;
        });
    }, [
        setIsOpen
    ]);
    var onCloseDialog = (0, $91i6m.useCallback)(function() {
        return setIsOpen(false);
    }, [
        setIsOpen
    ]);
    if (!appearance) appearance = type;
    return /*#__PURE__*/ $91i6m.createElement("div", {
        "data-testid": testId,
        className: (0, $9gzWK.default)([
            "_1e0c1o8l _p12f1osq _nt751r31 _49pcnqa1 _1hvwt94y _kvh01r31 _38q98stv _1o0knqa1 _1yyu1kum",
            $4010b6391fd55cd8$var$iconColor[appearance]
        ])
    }, /*#__PURE__*/ $91i6m.createElement((0, $hTumZ.default), {
        onClose: onCloseDialog,
        content: children,
        isOpen: isOpen,
        placement: placement,
        testId: testId && "".concat(testId, "--inline-dialog")
    }, /*#__PURE__*/ $91i6m.createElement((0, $2yRMe.default), {
        "data-ds--inline-message--button": true,
        appearance: "subtle-link",
        onClick: toggleDialog,
        spacing: "none",
        testId: testId && "".concat(testId, "--button"),
        "aria-expanded": isOpen
    }, /*#__PURE__*/ $91i6m.createElement((0, $cS1ZL.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $91i6m.createElement((0, $7xwGT.default), {
        isOpen: isOpen,
        appearance: appearance,
        label: iconLabel
    }), /*#__PURE__*/ $91i6m.createElement((0, $cS1ZL.default), {
        space: "space.100"
    }, title && /*#__PURE__*/ $91i6m.createElement((0, $gMobs.default), {
        weight: "medium",
        testId: testId && "".concat(testId, "--title")
    }, title), secondaryText && /*#__PURE__*/ $91i6m.createElement((0, $gMobs.default), {
        weight: "medium",
        color: "color.text.subtlest",
        maxLines: 1,
        testId: testId && "".concat(testId, "--text")
    }, secondaryText))))));
};
var $4010b6391fd55cd8$export$2e2bcd8739ae039 = $4010b6391fd55cd8$var$InlineMessage;

});
parcelRegister("2yRMe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1dd878bde5fee668$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $5YM7L = parcelRequire("5YM7L");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $6F00t = parcelRequire("6F00t");

var $getcU = parcelRequire("getcU");

var $lxdbj = parcelRequire("lxdbj");

var $grvaj = parcelRequire("grvaj");

var $fSF1K = parcelRequire("fSF1K");
var $1dd878bde5fee668$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $1dd878bde5fee668$var$isFirefox = typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ var $1dd878bde5fee668$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $6F00t.default) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $6F00t.default) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $1dd878bde5fee668$var$_excluded);
    var _useGlobalTheme = (0, $getcU.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var isOnlySingleIcon = (0, $fSF1K.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $91i6m.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    var onMouseDown = (0, $91i6m.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($1dd878bde5fee668$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $91i6m.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($1dd878bde5fee668$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $91i6m.useMemo)(function() {
        return (0, $grvaj.getCss)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $lxdbj.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$1dd878bde5fee668$var$Button.displayName = "Button";
var $1dd878bde5fee668$export$2e2bcd8739ae039 = $1dd878bde5fee668$var$Button;

});
parcelRegister("6F00t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d9693b4f7725edf$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $4d9693b4f7725edf$export$2e2bcd8739ae039() {}

});

parcelRegister("getcU", function(module, exports) {

$parcel$export(module.exports, "useGlobalTheme", function () { return $bd149c10e4c4826b$export$7692396083754928; });

var $59BPs = parcelRequire("59BPs");
// Create default global light theme
var $bd149c10e4c4826b$var$_createTheme = (0, $59BPs.createTheme)(function() {
    return {
        mode: "light"
    };
}), $bd149c10e4c4826b$var$Provider = $bd149c10e4c4826b$var$_createTheme.Provider, $bd149c10e4c4826b$var$Consumer = $bd149c10e4c4826b$var$_createTheme.Consumer, $bd149c10e4c4826b$export$7692396083754928 = $bd149c10e4c4826b$var$_createTheme.useTheme;
var $bd149c10e4c4826b$var$Theme = {
    Provider: $bd149c10e4c4826b$var$Provider,
    Consumer: $bd149c10e4c4826b$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bd149c10e4c4826b$export$2e2bcd8739ae039 = $bd149c10e4c4826b$var$Theme;

});
parcelRegister("59BPs", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $3c0b230fb57044a9$export$25d302a5b900a763; });

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");
var $3c0b230fb57044a9$var$_excluded = [
    "children"
];
function $3c0b230fb57044a9$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $91i6m.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $91i6m.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(props, $3c0b230fb57044a9$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $91i6m.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $91i6m.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("lxdbj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fad6e797bf684f04$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $lPOF7 = parcelRequire("lPOF7");

var $8CWSI = parcelRequire("8CWSI");

var $6F00t = parcelRequire("6F00t");

var $1CMBg = parcelRequire("1CMBg");

var $8qscR = parcelRequire("8qscR");

var $9Z4op = parcelRequire("9Z4op");

var $cssbj = parcelRequire("cssbj");

var $kzna3 = parcelRequire("kzna3");

var $grvaj = parcelRequire("grvaj");

var $4TisO = parcelRequire("4TisO");
var $fad6e797bf684f04$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $fad6e797bf684f04$var$noPointerEventsOnChildrenCss = {
    "> *": {
        pointerEvents: "none"
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $fad6e797bf684f04$var$iconBeforeSpacingFixStyle = (0, $lPOF7.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-025, 2px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $fad6e797bf684f04$var$iconAfterSpacingFixStyle = (0, $lPOF7.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-050, 4px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $fad6e797bf684f04$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $4TisO.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
var $fad6e797bf684f04$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $4TisO.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $lPOF7.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $fad6e797bf684f04$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "default" : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? "a" : "button" : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $6F00t.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $6F00t.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? "default" : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? "button" : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(props, $fad6e797bf684f04$var$_excluded);
    var ourRef = (0, $91i6m.useRef)();
    var setRef = (0, $91i6m.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === "function") {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $1CMBg.default)(ourRef, autoFocus);
    var interactionContext = (0, $91i6m.useContext)((0, $9Z4op.default));
    var handleClick = (0, $91i6m.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $8CWSI.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: "button",
        packageName: "@atlaskit/button",
        packageVersion: "23.0.3",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $91i6m.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $91i6m.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $lPOF7.css)((0, $grvaj.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === "warning") spinnerHackCss = {
        "[data-theme] & circle": {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $cssbj.N500), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $cssbj.N500), ")"), " !important")
        }
    };
    return (0, $lPOF7.jsx)((0, $8qscR.default), null, (0, $lPOF7.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $fad6e797bf684f04$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $kzna3.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $lPOF7.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $grvaj.getIconStyle)({
                spacing: spacing
            }),
            $fad6e797bf684f04$var$getSpacingFix(children, $fad6e797bf684f04$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $fad6e797bf684f04$var$getChildren(children, [
        fadeStyles,
        (0, $grvaj.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $lPOF7.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $grvaj.getIconStyle)({
                spacing: spacing
            }),
            $fad6e797bf684f04$var$getSpacingFix(children, $fad6e797bf684f04$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $lPOF7.jsx)("span", {
        css: [
            (0, $grvaj.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fad6e797bf684f04$export$2e2bcd8739ae039 = $fad6e797bf684f04$var$ButtonBase;

});
parcelRegister("8CWSI", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $647f8bffa16f641f$export$a4687b0234b40e28; });

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $hlDCu = parcelRequire("hlDCu");

var $ld6ls = parcelRequire("ld6ls");
function $647f8bffa16f641f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $647f8bffa16f641f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $647f8bffa16f641f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $647f8bffa16f641f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $647f8bffa16f641f$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $hlDCu.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $ld6ls.useTrackedRef)(analyticsData);
    var fnRef = (0, $ld6ls.useTrackedRef)(fn);
    var handler = (0, $91i6m.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $647f8bffa16f641f$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("hlDCu", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $ca132181f994c99f$export$5bf35293e545f20c; });

var $57aKu = parcelRequire("57aKu");

var $5v1Rj = parcelRequire("5v1Rj");

var $jA4sO = parcelRequire("jA4sO");
function $ca132181f994c99f$export$5bf35293e545f20c() {
    var analyticsContext = (0, $jA4sO.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $57aKu.useCallbackOne)(function(payload) {
        return new (0, $5v1Rj.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("5v1Rj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40114a27dd75fd67$export$2e2bcd8739ae039; });

var $iqLBO = parcelRequire("iqLBO");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $gGOBY = parcelRequire("gGOBY");

var $lVDuE = parcelRequire("lVDuE");

var $dX0BB = parcelRequire("dX0BB");

var $kSyoi = parcelRequire("kSyoi");

var $dsN6L = parcelRequire("dsN6L");

var $3F3xv = parcelRequire("3F3xv");
function $40114a27dd75fd67$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($gGOBY)))(t, $40114a27dd75fd67$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(t).constructor) : o.apply(t, e));
}
function $40114a27dd75fd67$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($40114a27dd75fd67$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $40114a27dd75fd67$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dX0BB)))((0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $40114a27dd75fd67$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $40114a27dd75fd67$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $40114a27dd75fd67$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, UIAnalyticsEvent);
        _this = $40114a27dd75fd67$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($kSyoi)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $40114a27dd75fd67$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $3F3xv.default));

});
parcelRegister("3F3xv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2aa7f2430882b8a3$export$2e2bcd8739ae039; });

var $61RDg = parcelRequire("61RDg");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $dsN6L = parcelRequire("dsN6L");
function $2aa7f2430882b8a3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2aa7f2430882b8a3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2aa7f2430882b8a3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2aa7f2430882b8a3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2aa7f2430882b8a3$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $2aa7f2430882b8a3$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $2aa7f2430882b8a3$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $2aa7f2430882b8a3$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(updater) === "object") this.payload = $2aa7f2430882b8a3$var$_objectSpread($2aa7f2430882b8a3$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("jA4sO", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $e414d78629c00589$export$d1f587f82ad51c4; });

var $91i6m = parcelRequire("91i6m");

var $6Jo8f = parcelRequire("6Jo8f");
var $e414d78629c00589$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $91i6m.useContext)((0, $6Jo8f.default));
};

});


parcelRegister("ld6ls", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $f70fbbde0109fe4e$export$1d27a74659855e44; });

var $91i6m = parcelRequire("91i6m");
var $f70fbbde0109fe4e$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $91i6m.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("1CMBg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12ef09ff3cc4232f$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");
function $12ef09ff3cc4232f$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $91i6m.useRef)(true);
    (0, $91i6m.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("8qscR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6226a1a170c40254$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $91i6m = parcelRequire("91i6m");

var $lPOF7 = parcelRequire("lPOF7");
var $6226a1a170c40254$var$BORDER_WIDTH = 2;
var $6226a1a170c40254$var$baseFocusOutsideStyles = (0, $lPOF7.css)({
    outline: "".concat($6226a1a170c40254$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $6226a1a170c40254$var$BORDER_WIDTH
});
var $6226a1a170c40254$var$baseInsetStyles = (0, $lPOF7.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$6226a1a170c40254$var$BORDER_WIDTH,
    outlineStyle: "solid",
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $6226a1a170c40254$var$focusRingStyles = (0, $lPOF7.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $6226a1a170c40254$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $6226a1a170c40254$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $6226a1a170c40254$var$insetFocusRingStyles = (0, $lPOF7.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $6226a1a170c40254$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $6226a1a170c40254$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: "-1px"
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $6226a1a170c40254$var$FocusRing = /*#__PURE__*/ (0, $91i6m.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $6226a1a170c40254$var$baseInsetStyles : $6226a1a170c40254$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $6226a1a170c40254$var$insetFocusRingStyles : $6226a1a170c40254$var$focusRingStyles;
    var focusCls = typeof focus === "undefined" ? uncontrolledStyles : focus === "on" && controlledStyles;
    return (0, $lPOF7.jsx)((0, $lPOF7.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $91i6m.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $91i6m.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$6226a1a170c40254$var$FocusRing.displayName = "FocusRing";
var $6226a1a170c40254$export$2e2bcd8739ae039 = $6226a1a170c40254$var$FocusRing;

});

parcelRegister("9Z4op", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $744d37d8166ace14$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");
var $744d37d8166ace14$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $91i6m.createContext)(null);

});

parcelRegister("cssbj", function(module, exports) {

$parcel$export(module.exports, "R300", function () { return $911df5cc383199b4$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $911df5cc383199b4$export$2010d0fb4295b346; });
$parcel$export(module.exports, "R500", function () { return $911df5cc383199b4$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y200", function () { return $911df5cc383199b4$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y300", function () { return $911df5cc383199b4$export$c6930421db9fa514; });
$parcel$export(module.exports, "Y400", function () { return $911df5cc383199b4$export$59619663aa6500fb; });
$parcel$export(module.exports, "B50", function () { return $911df5cc383199b4$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $911df5cc383199b4$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $911df5cc383199b4$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $911df5cc383199b4$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $911df5cc383199b4$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $911df5cc383199b4$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $911df5cc383199b4$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "N0", function () { return $911df5cc383199b4$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $911df5cc383199b4$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N70", function () { return $911df5cc383199b4$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N90", function () { return $911df5cc383199b4$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N200", function () { return $911df5cc383199b4$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N400", function () { return $911df5cc383199b4$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $911df5cc383199b4$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N700", function () { return $911df5cc383199b4$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $911df5cc383199b4$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $911df5cc383199b4$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $911df5cc383199b4$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN400", function () { return $911df5cc383199b4$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN300", function () { return $911df5cc383199b4$export$97e81faa16a182c7; });
$parcel$export(module.exports, "DN100", function () { return $911df5cc383199b4$export$ee82aa2ea6a1558; });
$parcel$export(module.exports, "DN70", function () { return $911df5cc383199b4$export$d281fbfe3cff2df6; });
$parcel$export(module.exports, "DN60", function () { return $911df5cc383199b4$export$3902c91d8b98a753; });
$parcel$export(module.exports, "DN30", function () { return $911df5cc383199b4$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN0", function () { return $911df5cc383199b4$export$3d4f271a500072a; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $911df5cc383199b4$export$4b84fd0e2c617bd = "#FFEBE6";
var $911df5cc383199b4$export$b34b069eff244586 = "#FFBDAD";
var $911df5cc383199b4$export$be802dd0d8b57f35 = "#FF8F73";
var $911df5cc383199b4$export$60847d42f9da92a6 = "#FF7452";
var $911df5cc383199b4$export$4a7404f376229999 = "#FF5630";
var $911df5cc383199b4$export$2010d0fb4295b346 = "#DE350B";
var $911df5cc383199b4$export$2837b5a1a71d5c02 = "#BF2600";
var $911df5cc383199b4$export$8d9596b529bbb9cf = "#FFFAE6";
var $911df5cc383199b4$export$41060a744ab0b7ae = "#FFF0B3";
var $911df5cc383199b4$export$1cc05bbbf340e559 = "#FFE380";
var $911df5cc383199b4$export$5aae31392d72caaa = "#FFC400";
var $911df5cc383199b4$export$c6930421db9fa514 = "#FFAB00";
var $911df5cc383199b4$export$59619663aa6500fb = "#FF991F";
var $911df5cc383199b4$export$874739ea9e379ab6 = "#FF8B00";
var $911df5cc383199b4$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $911df5cc383199b4$export$69a3bf21b9686c2b = "#ABF5D1";
var $911df5cc383199b4$export$afbce1382ec95f73 = "#79F2C0";
var $911df5cc383199b4$export$747d86715d4175de = "#57D9A3";
var $911df5cc383199b4$export$940e1f69e873f202 = "#36B37E";
var $911df5cc383199b4$export$a49394138f7b8e85 = "#00875A";
var $911df5cc383199b4$export$6fa04827ac68a4fb = "#006644";
var $911df5cc383199b4$export$226de0355ed012f8 = "#DEEBFF";
var $911df5cc383199b4$export$8c13c2ee36917869 = "#B3D4FF";
var $911df5cc383199b4$export$ecfc1dff386a3e7a = "#4C9AFF";
var $911df5cc383199b4$export$215b7063051591f1 = "#2684FF";
var $911df5cc383199b4$export$e62e8919cca44969 = "#0065FF";
var $911df5cc383199b4$export$b3de0ae08da2ce64 = "#0052CC";
var $911df5cc383199b4$export$a6ee3d71bc067634 = "#0747A6";
var $911df5cc383199b4$export$67f15409e87642a1 = "#669DF1";
var $911df5cc383199b4$export$f0539dbc42dbb067 = "#8FB8F6";
var $911df5cc383199b4$export$363e4475840015bb = "#EAE6FF";
var $911df5cc383199b4$export$4b0a4417ed59760f = "#C0B6F2";
var $911df5cc383199b4$export$6011520a64d9a187 = "#998DD9";
var $911df5cc383199b4$export$a7175d4e9206bc80 = "#8777D9";
var $911df5cc383199b4$export$b48405b95304b5a1 = "#6554C0";
var $911df5cc383199b4$export$c71e4279dd54a18d = "#5243AA";
var $911df5cc383199b4$export$147899de772240ec = "#403294";
var $911df5cc383199b4$export$2cf711fe14c66f06 = "#E6FCFF";
var $911df5cc383199b4$export$7a8f4d33f6f9772c = "#B3F5FF";
var $911df5cc383199b4$export$776c9c497ef08533 = "#79E2F2";
var $911df5cc383199b4$export$69cb3ca10c1e330e = "#00C7E6";
var $911df5cc383199b4$export$9dc1ef0f3f48059b = "#00B8D9";
var $911df5cc383199b4$export$7c835c78b6fcdef8 = "#00A3BF";
var $911df5cc383199b4$export$6036577f95c3877e = "#008DA6";
var $911df5cc383199b4$export$29a4f05edc054374 = "#FFFFFF";
var $911df5cc383199b4$export$e655ef011c4aa1a2 = "#FAFBFC";
var $911df5cc383199b4$export$9fdfb749e33cdf97 = "#F4F5F7";
var $911df5cc383199b4$export$3e51e8f1440314ba = "#EBECF0";
var $911df5cc383199b4$export$1ce2d1575d444ceb = "#DFE1E6";
var $911df5cc383199b4$export$8754fc7e6d8b3000 = "#C1C7D0";
var $911df5cc383199b4$export$c2e91cbeada39b8b = "#B3BAC5";
var $911df5cc383199b4$export$5f71e19f3a7ad9de = "#A5ADBA";
var $911df5cc383199b4$export$eaa8c8a70ac22806 = "#97A0AF";
var $911df5cc383199b4$export$7c87d337fb91a97d = "#8993A4";
var $911df5cc383199b4$export$d6447c357493214f = "#7A869A";
var $911df5cc383199b4$export$f563ee71e9ee74cd = "#6B778C";
var $911df5cc383199b4$export$e2ef2124cf4024b1 = "#5E6C84";
var $911df5cc383199b4$export$eece5f492e429f08 = "#505F79";
var $911df5cc383199b4$export$c39c0fe0f26207ae = "#42526E";
var $911df5cc383199b4$export$7090862dc3038a9f = "#344563";
var $911df5cc383199b4$export$ad0bacf983b7ddaa = "#253858";
var $911df5cc383199b4$export$7d61b15e0da132af = "#172B4D";
var $911df5cc383199b4$export$fbda843f0a27fe96 = "#091E42";
var $911df5cc383199b4$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $911df5cc383199b4$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $911df5cc383199b4$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $911df5cc383199b4$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $911df5cc383199b4$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $911df5cc383199b4$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $911df5cc383199b4$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $911df5cc383199b4$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $911df5cc383199b4$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $911df5cc383199b4$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $911df5cc383199b4$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $911df5cc383199b4$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $911df5cc383199b4$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $911df5cc383199b4$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $911df5cc383199b4$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $911df5cc383199b4$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $911df5cc383199b4$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $911df5cc383199b4$export$2f6319cf7d736c2a = "#E6EDFA";
var $911df5cc383199b4$export$95126bc8884d6634 = "#DCE5F5";
var $911df5cc383199b4$export$8338d8c35d44ff1 = "#CED9EB";
var $911df5cc383199b4$export$5368d76ae4fbbda7 = "#B8C7E0";
var $911df5cc383199b4$export$9f0a771d16ec8d36 = "#ABBBD6";
var $911df5cc383199b4$export$abcf8c38338b4aa5 = "#9FB0CC";
var $911df5cc383199b4$export$97e81faa16a182c7 = "#8C9CB8";
var $911df5cc383199b4$export$bfe21c59123ecf33 = "#7988A3";
var $911df5cc383199b4$export$ee82aa2ea6a1558 = "#67758F";
var $911df5cc383199b4$export$682927c6ed76be02 = "#56637A";
var $911df5cc383199b4$export$91fd9994c5be9757 = "#455166";
var $911df5cc383199b4$export$d281fbfe3cff2df6 = "#3B475C";
var $911df5cc383199b4$export$3902c91d8b98a753 = "#313D52";
var $911df5cc383199b4$export$8e8133c1ba5845b5 = "#283447";
var $911df5cc383199b4$export$33ff357f6620b39 = "#202B3D";
var $911df5cc383199b4$export$633847cf062b69e0 = "#1B2638";
var $911df5cc383199b4$export$9776a6e503bdbf76 = "#121A29";
var $911df5cc383199b4$export$6c813d5160dff5db = "#0E1624";
var $911df5cc383199b4$export$3d4f271a500072a = "#0D1424";
var $911df5cc383199b4$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $911df5cc383199b4$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $911df5cc383199b4$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $911df5cc383199b4$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $911df5cc383199b4$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $911df5cc383199b4$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $911df5cc383199b4$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $911df5cc383199b4$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $911df5cc383199b4$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $911df5cc383199b4$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $911df5cc383199b4$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $911df5cc383199b4$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $911df5cc383199b4$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $911df5cc383199b4$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $911df5cc383199b4$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $911df5cc383199b4$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $911df5cc383199b4$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $911df5cc383199b4$export$d2adc5dedf09fced = "#292A2E";
var $911df5cc383199b4$export$f51762073d2bb381 = "#94C748";
var $911df5cc383199b4$export$95e26d54def96891 = "#B3DF72";

});

parcelRegister("kzna3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef990ad6fc5e406a$export$2e2bcd8739ae039; });
function $ef990ad6fc5e406a$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $ef990ad6fc5e406a$var$tabKeyCode = 9;
function $ef990ad6fc5e406a$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $ef990ad6fc5e406a$var$tabKeyCode) return;
    $ef990ad6fc5e406a$var$abort(event);
}
var $ef990ad6fc5e406a$var$block = {
    onMouseDownCapture: $ef990ad6fc5e406a$var$abort,
    onMouseUpCapture: $ef990ad6fc5e406a$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $ef990ad6fc5e406a$var$onKey,
    onKeyUpCapture: $ef990ad6fc5e406a$var$onKey,
    onTouchStartCapture: $ef990ad6fc5e406a$var$abort,
    onTouchEndCapture: $ef990ad6fc5e406a$var$abort,
    onPointerDownCapture: $ef990ad6fc5e406a$var$abort,
    onPointerUpCapture: $ef990ad6fc5e406a$var$abort,
    onClickCapture: $ef990ad6fc5e406a$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $ef990ad6fc5e406a$var$abort
};
var $ef990ad6fc5e406a$var$doNotBlock = {};
function $ef990ad6fc5e406a$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $ef990ad6fc5e406a$var$doNotBlock : $ef990ad6fc5e406a$var$block;
}

});

parcelRegister("grvaj", function(module, exports) {

$parcel$export(module.exports, "getCss", function () { return $bf8757b8434eb513$export$955358618f994a11; });
$parcel$export(module.exports, "getIconStyle", function () { return $bf8757b8434eb513$export$864eea3f4ec3368f; });
$parcel$export(module.exports, "getContentStyle", function () { return $bf8757b8434eb513$export$7ad0316cc0dd65a; });
$parcel$export(module.exports, "getFadingCss", function () { return $bf8757b8434eb513$export$1b5827d324e945b1; });
$parcel$export(module.exports, "overlayCss", function () { return $bf8757b8434eb513$export$1a9fe1b84c876bb5; });

var $dsN6L = parcelRequire("dsN6L");

var $lPOF7 = parcelRequire("lPOF7");

var $cqLfB = parcelRequire("cqLfB");

var $cwKJa = parcelRequire("cwKJa");

var $fO166 = parcelRequire("fO166");
function $bf8757b8434eb513$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bf8757b8434eb513$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bf8757b8434eb513$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bf8757b8434eb513$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $bf8757b8434eb513$var$gridSize = (0, $cwKJa.gridSize)();
var $bf8757b8434eb513$var$HAS_DISABLED_BACKGROUND = [
    "default",
    "primary",
    "danger",
    "warning"
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $bf8757b8434eb513$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: "auto"
};
var $bf8757b8434eb513$var$lineHeights = {
    default: $bf8757b8434eb513$var$heights.default,
    compact: $bf8757b8434eb513$var$heights.compact,
    none: "inherit"
};
var $bf8757b8434eb513$var$padding = {
    // 10px gutter
    default: "0 ".concat($bf8757b8434eb513$var$gridSize + $bf8757b8434eb513$var$gridSize / 4, "px"),
    compact: "0 ".concat($bf8757b8434eb513$var$gridSize + $bf8757b8434eb513$var$gridSize / 4, "px"),
    none: "0"
};
var $bf8757b8434eb513$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($bf8757b8434eb513$var$gridSize / 4, "px"),
    default: "0 ".concat($bf8757b8434eb513$var$gridSize / 4, "px"),
    none: "0"
};
var $bf8757b8434eb513$var$verticalAlign = {
    default: "middle",
    compact: "middle",
    none: "baseline"
};
var $bf8757b8434eb513$var$innerMargin = {
    content: "0 ".concat($bf8757b8434eb513$var$gridSize / 4, "px"),
    icon: "0 ".concat($bf8757b8434eb513$var$gridSize / 4, "px")
};
var $bf8757b8434eb513$var$defaultAfterStyles = {
    borderRadius: "inherit",
    inset: "var(--ds-space-0, 0px)",
    borderStyle: "solid",
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: "none",
    position: "absolute"
};
var $bf8757b8434eb513$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #172B4D)",
    "&:not([disabled])::after": $bf8757b8434eb513$var$_objectSpread($bf8757b8434eb513$var$_objectSpread({}, $bf8757b8434eb513$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #091E4224)"
    }),
    "&:hover": {
        background: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-pressed, #091E424F)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $bf8757b8434eb513$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #0C66E4)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-brand-bold-hovered, #0055CC)"
    },
    "&:active": {
        background: "var(--ds-background-brand-bold-pressed, #09326C)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #0C66E4)"
    }
};
var $bf8757b8434eb513$var$linkStyles = {
    background: "transparent",
    color: "var(--ds-link, #0C66E4)",
    "&:hover": {
        color: "var(--ds-link, #0C66E4)",
        textDecoration: "underline"
    },
    "&:active": {
        color: "var(--ds-link-pressed, #0055CC)",
        textDecoration: "underline"
    }
};
var $bf8757b8434eb513$var$subtleStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #44546F)",
    "&:hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "transparent"
    }
};
var $bf8757b8434eb513$var$subtleLinkStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #44546F)",
    "&:hover": {
        background: "transparent",
        color: "var(--ds-text-subtle, #44546F)",
        textDecoration: "underline"
    },
    "&:active": {
        background: "transparent",
        color: "var(--ds-text, #172B4D)",
        textDecoration: "underline"
    }
};
var $bf8757b8434eb513$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #F5CD47)",
    color: "var(--ds-text-warning-inverse, #172B4D)",
    "&:hover": {
        background: "var(--ds-background-warning-bold-hovered, #E2B203)"
    },
    "&:active": {
        background: "var(--ds-background-warning-bold-pressed, #CF9F02)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #F5CD47)"
    }
};
var $bf8757b8434eb513$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    "&:active": {
        background: "var(--ds-background-danger-bold-pressed, #5D1F1A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $bf8757b8434eb513$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "var(--ds-text-selected, #0C66E4)",
    "&:not([disabled])::after": $bf8757b8434eb513$var$_objectSpread($bf8757b8434eb513$var$_objectSpread({}, $bf8757b8434eb513$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #0C66E4)"
    })
};
var $bf8757b8434eb513$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: "default",
        textDecoration: "none"
    }
};
function $bf8757b8434eb513$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $bf8757b8434eb513$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $bf8757b8434eb513$var$getColor({
            group: (0, $fO166.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($bf8757b8434eb513$var$getColor({
            group: (0, $fO166.default).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $bf8757b8434eb513$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $bf8757b8434eb513$var$getColors({
        appearance: appearance,
        key: isSelected ? "selected" : "default",
        mode: mode
    });
    return $bf8757b8434eb513$var$_objectSpread($bf8757b8434eb513$var$_objectSpread($bf8757b8434eb513$var$_objectSpread($bf8757b8434eb513$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: "baseline",
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: "border-box",
        display: "inline-flex",
        fontSize: "inherit",
        fontStyle: "normal",
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: "inherit",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: "100%",
        // Needed to position overlay
        position: "relative",
        textAlign: "center",
        textDecoration: "none",
        transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
        whiteSpace: "nowrap"
    }, !(0, $cqLfB.fg)("platform-component-visual-refresh") && baseColors), {}, {
        cursor: "pointer",
        height: $bf8757b8434eb513$var$heights[spacing],
        lineHeight: $bf8757b8434eb513$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $bf8757b8434eb513$var$singleIconPadding[spacing] : $bf8757b8434eb513$var$padding[spacing],
        verticalAlign: $bf8757b8434eb513$var$verticalAlign[spacing],
        width: shouldFitContainer ? "100%" : "auto",
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: "center"
    }, !(0, $cqLfB.fg)("platform-component-visual-refresh") && $bf8757b8434eb513$var$_objectSpread($bf8757b8434eb513$var$_objectSpread({
        // Disabling visited styles (just using the base colors)
        "&:visited": $bf8757b8434eb513$var$_objectSpread({}, baseColors),
        "&:hover": $bf8757b8434eb513$var$_objectSpread($bf8757b8434eb513$var$_objectSpread({}, $bf8757b8434eb513$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "hover",
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === "link" || appearance === "subtle-link") ? "underline" : "inherit",
            // background, box-shadow
            transitionDuration: "0s, 0.15s"
        }),
        // giving active styles preference by listing them after focus
        "&:active": $bf8757b8434eb513$var$_objectSpread($bf8757b8434eb513$var$_objectSpread({}, $bf8757b8434eb513$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $bf8757b8434eb513$var$_objectSpread($bf8757b8434eb513$var$_objectSpread({}, $bf8757b8434eb513$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        "&[disabled]": $bf8757b8434eb513$var$_objectSpread($bf8757b8434eb513$var$_objectSpread({}, $bf8757b8434eb513$var$getColors({
            appearance: appearance,
            key: "disabled",
            mode: mode
        })), {}, {
            cursor: "not-allowed",
            textDecoration: "none"
        })
    }, $bf8757b8434eb513$var$hasOverlayStyles), {}, {
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $bf8757b8434eb513$var$_objectSpread({}, $bf8757b8434eb513$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "default",
            mode: mode
        }))
    })), (0, $cqLfB.fg)("platform-component-visual-refresh") && (isSelected ? $bf8757b8434eb513$var$selectedStyles : $bf8757b8434eb513$var$_objectSpread($bf8757b8434eb513$var$_objectSpread($bf8757b8434eb513$var$_objectSpread($bf8757b8434eb513$var$_objectSpread($bf8757b8434eb513$var$_objectSpread($bf8757b8434eb513$var$_objectSpread($bf8757b8434eb513$var$_objectSpread($bf8757b8434eb513$var$_objectSpread({}, appearance === "default" && $bf8757b8434eb513$var$defaultStyles), appearance === "primary" && $bf8757b8434eb513$var$primaryStyles), appearance === "link" && $bf8757b8434eb513$var$linkStyles), appearance === "subtle" && $bf8757b8434eb513$var$subtleStyles), appearance === "subtle-link" && $bf8757b8434eb513$var$subtleLinkStyles), appearance === "warning" && $bf8757b8434eb513$var$warningStyles), appearance === "danger" && $bf8757b8434eb513$var$dangerStyles), {}, {
        "&[disabled]": {
            color: "var(--ds-text-disabled, #091E424F)",
            backgroundColor: $bf8757b8434eb513$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent",
            cursor: "not-allowed",
            textDecoration: "none",
            "&:hovered": {
                backgroundColor: $bf8757b8434eb513$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent"
            },
            "&:active": {
                backgroundColor: $bf8757b8434eb513$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent"
            }
        }
    }, $bf8757b8434eb513$var$hasOverlayStyles))), {}, {
        "&::-moz-focus-inner": {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $bf8757b8434eb513$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $lPOF7.css)({
        display: "flex",
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $bf8757b8434eb513$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: "center",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: "none"
    });
}
function $bf8757b8434eb513$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $lPOF7.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $bf8757b8434eb513$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    });
}
function $bf8757b8434eb513$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $lPOF7.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: "opacity 0.3s"
    });
}
var $bf8757b8434eb513$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

});
parcelRegister("cqLfB", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $90cc90c0f03a427c$export$b40ec24ac8275656; });

var $gL1pF = parcelRequire("gL1pF");
function $90cc90c0f03a427c$export$ba05d765b8392e5e(flagResolver) {
    (0, $gL1pF.setBooleanResolver)(flagResolver);
}
function $90cc90c0f03a427c$export$470e5c2be1411c89(name) {
    return (0, $gL1pF.resolveBooleanFlag)(name);
}
function $90cc90c0f03a427c$export$b40ec24ac8275656(name) {
    return (0, $gL1pF.resolveBooleanFlag)(name);
}

});
parcelRegister("gL1pF", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $c33221b689589e02$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $c33221b689589e02$export$6333b6aff9fc6275; });

var $kRYwT = parcelRequire("kRYwT");

var $2PFcC = parcelRequire("2PFcC");

var $e08gr = parcelRequire("e08gr");
var $c33221b689589e02$var$pkgName = "@atlaskit/platform-feature-flags";
var $c33221b689589e02$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $c33221b689589e02$var$hasProcessEnv = typeof $e08gr !== "undefined" && typeof $e08gr.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $c33221b689589e02$var$ENV_ENABLE_PLATFORM_FF = $c33221b689589e02$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $c33221b689589e02$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $c33221b689589e02$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $c33221b689589e02$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $c33221b689589e02$var$ENV_ENABLE_PLATFORM_FF || $c33221b689589e02$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $c33221b689589e02$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $c33221b689589e02$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$c33221b689589e02$var$globalVar[$c33221b689589e02$export$7e41b1b2bdee3f98] = $c33221b689589e02$var$globalVar[$c33221b689589e02$export$7e41b1b2bdee3f98] || $c33221b689589e02$var$DEFAULT_PFF_GLOBAL;
function $c33221b689589e02$export$f2b591175b3e424c(resolver) {
    $c33221b689589e02$var$globalVar[$c33221b689589e02$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $c33221b689589e02$export$6333b6aff9fc6275(flagKey) {
    if ($c33221b689589e02$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $2PFcC.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $c33221b689589e02$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $c33221b689589e02$var$globalVar[$c33221b689589e02$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $c33221b689589e02$var$globalVar[$c33221b689589e02$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $kRYwT.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $c33221b689589e02$var$globalVar[$c33221b689589e02$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("2PFcC", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $21004e2466445e0c$export$1c9f709888824e05; });
var $21004e2466445e0c$var$_process, $21004e2466445e0c$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $21004e2466445e0c$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($21004e2466445e0c$var$_process = globalThis.process) === null || $21004e2466445e0c$var$_process === void 0 || ($21004e2466445e0c$var$_process = $21004e2466445e0c$var$_process.env) === null || $21004e2466445e0c$var$_process === void 0 ? void 0 : $21004e2466445e0c$var$_process.JEST_WORKER_ID) !== undefined;
var $21004e2466445e0c$var$DEBUG_MODE = !$21004e2466445e0c$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($21004e2466445e0c$var$_process2 = globalThis.process) === null || $21004e2466445e0c$var$_process2 === void 0 || ($21004e2466445e0c$var$_process2 = $21004e2466445e0c$var$_process2.env) === null || $21004e2466445e0c$var$_process2 === void 0 ? void 0 : $21004e2466445e0c$var$_process2.NODE_ENV) !== "production";
var $21004e2466445e0c$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$21004e2466445e0c$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("cwKJa", function(module, exports) {

$parcel$export(module.exports, "gridSize", function () { return $91ecb85375be5e56$export$6d8204c2cb2e06b8; });

var $aVVDb = parcelRequire("aVVDb");

var $cssbj = parcelRequire("cssbj");
var $91ecb85375be5e56$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $91ecb85375be5e56$export$c93026a968943f95 = "light";
var $91ecb85375be5e56$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $91ecb85375be5e56$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $91ecb85375be5e56$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $91ecb85375be5e56$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $cssbj.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $91ecb85375be5e56$export$6d8204c2cb2e06b8() / 4;
    (0, $aVVDb.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $91ecb85375be5e56$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $91ecb85375be5e56$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $91ecb85375be5e56$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $aVVDb.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $91ecb85375be5e56$export$ba1d834b86d72a09 = $91ecb85375be5e56$export$a1b3edb637fb4f35;
var $91ecb85375be5e56$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $cssbj.N20A), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $cssbj.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $cssbj.N30A), ")")
            }
        }
    };
};

});
parcelRegister("aVVDb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f5bee8c631f4e90$export$2e2bcd8739ae039; });

var $imzxl = parcelRequire("imzxl");

var $e08gr = parcelRequire("e08gr");
function $7f5bee8c631f4e90$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $imzxl.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $7f5bee8c631f4e90$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $e08gr;
}

});
parcelRegister("imzxl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5e5d8f51053e50b$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $d5e5d8f51053e50b$var$printed = {};
function $d5e5d8f51053e50b$export$2e2bcd8739ae039(message) {
    if ($d5e5d8f51053e50b$var$printed[message]) return;
    $d5e5d8f51053e50b$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}

});



parcelRegister("fO166", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b81c606fca454541$export$2e2bcd8739ae039; });

var $cssbj = parcelRequire("cssbj");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $b81c606fca454541$var$fadedB75 = "rgba(179, 212, 255, 0.6)";
var $b81c606fca454541$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($cssbj.N20A, ")"),
                dark: "var(--ds-background-neutral, ".concat($cssbj.DN70, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($cssbj.N30A, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($cssbj.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($b81c606fca454541$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($cssbj.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($cssbj.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($cssbj.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($cssbj.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cssbj.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($cssbj.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cssbj.DN0, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($cssbj.B400, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($cssbj.B100, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($cssbj.B300, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($cssbj.B75, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($cssbj.B500, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($cssbj.B200, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($cssbj.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($cssbj.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($cssbj.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cssbj.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($cssbj.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cssbj.DN0, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($cssbj.Y300, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($cssbj.Y300, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($cssbj.Y200, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($cssbj.Y200, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($cssbj.Y400, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($cssbj.Y400, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($cssbj.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($cssbj.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($cssbj.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($cssbj.Y400, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($cssbj.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($cssbj.Y400, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($cssbj.R400, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($cssbj.R400, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($cssbj.R300, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($cssbj.R300, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($cssbj.R500, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($cssbj.R500, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($cssbj.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($cssbj.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($cssbj.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($cssbj.R500, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($cssbj.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($cssbj.R500, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($cssbj.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cssbj.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($cssbj.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cssbj.N20, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($cssbj.N30A, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($cssbj.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($b81c606fca454541$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($cssbj.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($cssbj.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cssbj.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($cssbj.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cssbj.DN0, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($cssbj.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cssbj.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($cssbj.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cssbj.N20, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($cssbj.N500, ")"),
                dark: "var(--ds-text, ".concat($cssbj.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($cssbj.B400, ")"),
                dark: "var(--ds-text, ".concat($cssbj.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($cssbj.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($cssbj.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($cssbj.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cssbj.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($cssbj.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cssbj.DN400, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($cssbj.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($cssbj.DN30, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($cssbj.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($cssbj.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($cssbj.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cssbj.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($cssbj.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cssbj.DN400, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($cssbj.N800, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($cssbj.N800, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($cssbj.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($cssbj.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($cssbj.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($cssbj.N800, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($cssbj.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($cssbj.N800, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($cssbj.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($cssbj.N0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($cssbj.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($cssbj.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($cssbj.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($cssbj.N0, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($cssbj.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($cssbj.N0, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($cssbj.B400, ")"),
                dark: "var(--ds-link, ".concat($cssbj.B100, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($cssbj.B300, ")"),
                dark: "var(--ds-link, ".concat($cssbj.B75, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($cssbj.B500, ")"),
                dark: "var(--ds-link-pressed, ".concat($cssbj.B200, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($cssbj.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($cssbj.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($cssbj.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cssbj.N700, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($cssbj.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cssbj.N700, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($cssbj.N500, ")"),
                dark: "var(--ds-text, ".concat($cssbj.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($cssbj.B400, ")"),
                dark: "var(--ds-text, ".concat($cssbj.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($cssbj.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($cssbj.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($cssbj.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cssbj.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($cssbj.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cssbj.DN400, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-text-subtle, ".concat($cssbj.N200, ")"),
                dark: "var(--ds-text-subtle, ".concat($cssbj.DN400, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($cssbj.N90, ")"),
                dark: "var(--ds-text-subtle, ".concat($cssbj.B50, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($cssbj.N400, ")"),
                dark: "var(--ds-text, ".concat($cssbj.DN300, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($cssbj.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($cssbj.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($cssbj.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cssbj.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($cssbj.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cssbj.DN400, ")")
            }
        }
    }
};
var $b81c606fca454541$export$2e2bcd8739ae039 = $b81c606fca454541$var$values;

});


parcelRegister("4TisO", function(module, exports) {

$parcel$export(module.exports, "getIfVisuallyHiddenChildren", function () { return $38fa9ef6da4f8959$export$20bbd2efb0d734c4; });

var $91i6m = parcelRequire("91i6m");

var $i2kZu = parcelRequire("i2kZu");
var $38fa9ef6da4f8959$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $91i6m.isValidElement)(children) && children.type === (0, $i2kZu.default);
};

});
parcelRegister("i2kZu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d218b234afce88dc$export$2e2bcd8739ae039; });
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
var $d218b234afce88dc$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $d218b234afce88dc$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $91i6m.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $9gzWK.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c"
        ])
    }, children);
};
var $d218b234afce88dc$export$2e2bcd8739ae039 = $d218b234afce88dc$var$VisuallyHidden;

});



parcelRegister("fSF1K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8fbb94b8bc58928$export$2e2bcd8739ae039; });

var $4TisO = parcelRequire("4TisO");
function $b8fbb94b8bc58928$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $4TisO.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});


parcelRegister("hTumZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d06f218c186e52bb$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $aA6j8 = parcelRequire("aA6j8");

var $iNZrQ = parcelRequire("iNZrQ");

var $eJjyV = parcelRequire("eJjyV");

var $c284Y = parcelRequire("c284Y");
var $c9Gcy = parcelRequire("c9Gcy");

var $lehYd = parcelRequire("lehYd");

var $8z7c3 = parcelRequire("8z7c3");
var $ckiKG = parcelRequire("ckiKG");
var $6Xy2r = parcelRequire("6Xy2r");

var $3r4d1 = parcelRequire("3r4d1");

var $1aQVR = parcelRequire("1aQVR");
var $d06f218c186e52bb$var$_checkIsChildOfPortal = function checkIsChildOfPortal(node) {
    if (!node) return false;
    return node.classList && node.classList.contains("atlaskit-portal-container") || $d06f218c186e52bb$var$_checkIsChildOfPortal(node.parentElement);
};
// Close manager for layering
var $d06f218c186e52bb$var$CloseManager = function CloseManager(_ref) {
    var handleEscapeClose = _ref.handleEscapeClose, handleClick = _ref.handleClick;
    (0, $c9Gcy.useCloseOnEscapePress)({
        onClose: handleEscapeClose
    });
    var _useLayering = (0, $c9Gcy.useLayering)(), isLayerDisabled = _useLayering.isLayerDisabled;
    (0, $91i6m.useEffect)(function() {
        return (0, $aA6j8.bind)(window, {
            type: "click",
            listener: function listener(e) {
                if (isLayerDisabled()) return;
                handleClick(e);
            },
            options: {
                capture: true
            }
        });
    }, [
        handleClick,
        isLayerDisabled
    ]);
    // only create a dummy component for using ths hook in class component
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("span", null);
};
var $d06f218c186e52bb$var$InlineDialog = /*#__PURE__*/ (0, $91i6m.memo)(function InlineDialog(_ref2) {
    var _ref2$isOpen = _ref2.isOpen, isOpen = _ref2$isOpen === void 0 ? false : _ref2$isOpen, _ref2$onContentBlur = _ref2.onContentBlur, onContentBlur = _ref2$onContentBlur === void 0 ? (0, $eJjyV.default) : _ref2$onContentBlur, _ref2$onContentClick = _ref2.onContentClick, onContentClick = _ref2$onContentClick === void 0 ? (0, $eJjyV.default) : _ref2$onContentClick, _ref2$onContentFocus = _ref2.onContentFocus, onContentFocus = _ref2$onContentFocus === void 0 ? (0, $eJjyV.default) : _ref2$onContentFocus, _ref2$onClose = _ref2.onClose, providedOnClose = _ref2$onClose === void 0 ? (0, $eJjyV.default) : _ref2$onClose, _ref2$placement = _ref2.placement, placement = _ref2$placement === void 0 ? "bottom-start" : _ref2$placement, _ref2$strategy = _ref2.strategy, strategy = _ref2$strategy === void 0 ? "fixed" : _ref2$strategy, testId = _ref2.testId, content = _ref2.content, children = _ref2.children;
    var containerRef = (0, $91i6m.useRef)(null);
    var triggerRef = (0, $91i6m.useRef)(null);
    var onClose = (0, $iNZrQ.usePlatformLeafEventHandler)({
        fn: function fn(event) {
            return providedOnClose(event);
        },
        action: "closed",
        componentName: "inlineDialog",
        packageName: "@atlaskit/inline-dialog",
        packageVersion: "17.0.2"
    });
    // we put this into a ref to avoid handleCloseRequest having this as a dependency
    var onCloseRef = (0, $91i6m.useRef)(onClose);
    (0, $91i6m.useEffect)(function() {
        onCloseRef.current = onClose;
    });
    var handleCloseRequest = (0, $91i6m.useCallback)(function(event) {
        var target = event.target;
        // checks for when target is not HTMLElement
        if (!(target instanceof HTMLElement)) return;
        // TODO: This is to handle the case where the target is no longer in the DOM.
        // This happens with react-select in datetime picker. There might be other
        // edge cases for this.
        if (!document.body.contains(target)) return;
        if (isOpen) {
            var _onCloseRef$current;
            (_onCloseRef$current = onCloseRef.current) === null || _onCloseRef$current === void 0 || _onCloseRef$current.call(onCloseRef, {
                isOpen: false,
                event: event
            });
            return;
        }
        // handles the case where inline dialog opens portalled elements such as modal
        if ($d06f218c186e52bb$var$_checkIsChildOfPortal(target)) return;
        // call onClose if the click originated from outside the dialog
        if (containerRef.current && !containerRef.current.contains(target)) {
            var _onCloseRef$current2;
            (_onCloseRef$current2 = onCloseRef.current) === null || _onCloseRef$current2 === void 0 || _onCloseRef$current2.call(onCloseRef, {
                isOpen: false,
                event: event
            });
        }
    }, [
        isOpen
    ]);
    var handleClick = (0, $91i6m.useCallback)(function(event) {
        var _containerRef$current;
        // exit if we click outside but on the trigger — it can handle the clicks itself
        if (triggerRef.current && triggerRef.current.contains(event.target)) return;
        if ((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(event.target)) return;
        handleCloseRequest(event);
    }, [
        handleCloseRequest,
        containerRef,
        triggerRef
    ]);
    var popper = isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $ckiKG.Popper), {
        placement: placement,
        strategy: strategy
    }, function(_ref3) {
        var _ref4 = _ref3.ref, style = _ref3.style;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1aQVR.Container), {
            onBlur: onContentBlur,
            onFocus: onContentFocus,
            onClick: onContentClick,
            ref: function ref(node) {
                if (node) {
                    containerRef.current = node;
                    if (typeof _ref4 === "function") _ref4(node);
                    else _ref4.current = node;
                }
            },
            style: style,
            testId: testId
        }, typeof content === "function" ? content() : content);
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $8z7c3.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6Xy2r.Reference), null, function(_ref5) {
        var ref = _ref5.ref;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $3r4d1.default), {
            innerRef: function innerRef(node) {
                triggerRef.current = node;
                if (typeof ref === "function") ref(node);
                else ref.current = node;
            // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            },
            hasNodeResolver: !(0, $lehYd.fg)("platform_design_system_team_portal_logic_r18_fix")
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment, null, children));
    }), isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $c284Y.Layering), {
        isDisabled: false
    }, popper, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($d06f218c186e52bb$var$CloseManager, {
        handleEscapeClose: handleCloseRequest,
        handleClick: handleClick
    })) : popper);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d06f218c186e52bb$export$2e2bcd8739ae039 = $d06f218c186e52bb$var$InlineDialog;

});
parcelRegister("iNZrQ", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $db0c77eb634a70b2$export$a4687b0234b40e28; });

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $5O1l9 = parcelRequire("5O1l9");

var $iytAZ = parcelRequire("iytAZ");
function $db0c77eb634a70b2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $db0c77eb634a70b2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $db0c77eb634a70b2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $db0c77eb634a70b2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $db0c77eb634a70b2$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $5O1l9.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $iytAZ.useTrackedRef)(analyticsData);
    var fnRef = (0, $iytAZ.useTrackedRef)(fn);
    var handler = (0, $91i6m.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $db0c77eb634a70b2$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("5O1l9", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $43a2a96953fb4aa6$export$5bf35293e545f20c; });

var $57aKu = parcelRequire("57aKu");

var $6xrIy = parcelRequire("6xrIy");

var $9p5CJ = parcelRequire("9p5CJ");
function $43a2a96953fb4aa6$export$5bf35293e545f20c() {
    var analyticsContext = (0, $9p5CJ.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $57aKu.useCallbackOne)(function(payload) {
        return new (0, $6xrIy.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("6xrIy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c2b534bc79bd1d6$export$2e2bcd8739ae039; });

var $iqLBO = parcelRequire("iqLBO");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $gGOBY = parcelRequire("gGOBY");

var $lVDuE = parcelRequire("lVDuE");

var $dX0BB = parcelRequire("dX0BB");

var $kSyoi = parcelRequire("kSyoi");

var $dsN6L = parcelRequire("dsN6L");

var $6Z6n7 = parcelRequire("6Z6n7");
function $4c2b534bc79bd1d6$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($gGOBY)))(t, $4c2b534bc79bd1d6$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(t).constructor) : o.apply(t, e));
}
function $4c2b534bc79bd1d6$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($4c2b534bc79bd1d6$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $4c2b534bc79bd1d6$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dX0BB)))((0, (/*@__PURE__*/$parcel$interopDefault($lVDuE)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $4c2b534bc79bd1d6$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $4c2b534bc79bd1d6$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $4c2b534bc79bd1d6$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, UIAnalyticsEvent);
        _this = $4c2b534bc79bd1d6$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($kSyoi)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $4c2b534bc79bd1d6$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $6Z6n7.default));

});
parcelRegister("6Z6n7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $515d61e141fe186a$export$2e2bcd8739ae039; });

var $61RDg = parcelRequire("61RDg");

var $3lbuJ = parcelRequire("3lbuJ");

var $iTPYb = parcelRequire("iTPYb");

var $dsN6L = parcelRequire("dsN6L");
function $515d61e141fe186a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $515d61e141fe186a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $515d61e141fe186a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $515d61e141fe186a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $515d61e141fe186a$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $515d61e141fe186a$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $515d61e141fe186a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($3lbuJ)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $515d61e141fe186a$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTPYb)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(updater) === "object") this.payload = $515d61e141fe186a$var$_objectSpread($515d61e141fe186a$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("9p5CJ", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $6d8acfa067036532$export$d1f587f82ad51c4; });

var $91i6m = parcelRequire("91i6m");

var $6Jo8f = parcelRequire("6Jo8f");
var $6d8acfa067036532$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $91i6m.useContext)((0, $6Jo8f.default));
};

});


parcelRegister("iytAZ", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $d8225c0526601d4f$export$1d27a74659855e44; });

var $91i6m = parcelRequire("91i6m");
var $d8225c0526601d4f$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $91i6m.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("eJjyV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab947158cff576b0$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $ab947158cff576b0$export$2e2bcd8739ae039() {}

});

parcelRegister("c284Y", function(module, exports) {

$parcel$export(module.exports, "LevelContext", function () { return $8c2bf04cc1f56586$export$650d12d3c2ddb8fc; });
$parcel$export(module.exports, "TopLevelContext", function () { return $8c2bf04cc1f56586$export$48b383b280e20440; });
$parcel$export(module.exports, "Layering", function () { return $8c2bf04cc1f56586$export$7c885f891c940977; });

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $eJjyV = parcelRequire("eJjyV");

var $lehYd = parcelRequire("lehYd");
function $8c2bf04cc1f56586$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8c2bf04cc1f56586$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8c2bf04cc1f56586$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8c2bf04cc1f56586$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8c2bf04cc1f56586$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $91i6m.createContext)(0);
var $8c2bf04cc1f56586$export$48b383b280e20440 = /*#__PURE__*/ (0, $91i6m.createContext)({
    topLevelRef: {
        current: null
    },
    layerList: {
        current: null
    },
    setTopLevel: (0, $eJjyV.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $8c2bf04cc1f56586$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $91i6m.useContext)($8c2bf04cc1f56586$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel, topLevelRef = _useContext.topLevelRef, layerList = _useContext.layerList;
    // This is not unstable, it will run once for ref creation.
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var id = (0, $91i6m.useRef)((0, $lehYd.fg)("layering-top-level-use-array") ? Math.random().toString(36) : "");
    if (!(0, $lehYd.fg)("layering-top-level-use-array")) {
        if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
    }
    if (!(0, $lehYd.fg)("layering-top-level-use-array")) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $91i6m.useEffect)(function() {
        return function() {
            // avoid immediate cleanup using setTimeout when component unmount
            // this will make sure non-top layer components can get the correct top level value
            // when multiple layers trigger onClose in sequence
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel,
        topLevelRef
    ]);
    if ((0, $lehYd.fg)("layering-top-level-use-array")) // Remove eslint error on FG cleanup
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $91i6m.useEffect)(function() {
        var safeLayerList = layerList === null || layerList === void 0 ? void 0 : layerList.current;
        var safeId = id.current;
        if (!safeLayerList) return;
        safeLayerList.push(safeId);
        return function() {
            var index = safeLayerList.indexOf(safeId);
            if (index > -1) safeLayerList.splice(index, 1);
        };
    }, [
        layerList,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($8c2bf04cc1f56586$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $8c2bf04cc1f56586$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $91i6m.useRef)(0);
    var layerList = (0, $91i6m.useRef)([]);
    var value = (0, $91i6m.useMemo)(function() {
        return $8c2bf04cc1f56586$var$_objectSpread({
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        }, (0, $lehYd.fg)("layering-top-level-use-array") ? {
            layerList: layerList
        } : {});
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($8c2bf04cc1f56586$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $8c2bf04cc1f56586$export$7c885f891c940977 = function Layering(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $91i6m.useContext)($8c2bf04cc1f56586$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($8c2bf04cc1f56586$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($8c2bf04cc1f56586$var$LayeringProvider, null, content);
};

});
parcelRegister("lehYd", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $f748d844fc0d1e4b$export$b40ec24ac8275656; });

var $3pa9C = parcelRequire("3pa9C");
function $f748d844fc0d1e4b$export$ba05d765b8392e5e(flagResolver) {
    (0, $3pa9C.setBooleanResolver)(flagResolver);
}
function $f748d844fc0d1e4b$export$470e5c2be1411c89(name) {
    return (0, $3pa9C.resolveBooleanFlag)(name);
}
function $f748d844fc0d1e4b$export$b40ec24ac8275656(name) {
    return (0, $3pa9C.resolveBooleanFlag)(name);
}

});
parcelRegister("3pa9C", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $27ab954f4581944a$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $27ab954f4581944a$export$6333b6aff9fc6275; });

var $kRYwT = parcelRequire("kRYwT");

var $eUsTo = parcelRequire("eUsTo");

var $e08gr = parcelRequire("e08gr");
var $27ab954f4581944a$var$pkgName = "@atlaskit/platform-feature-flags";
var $27ab954f4581944a$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $27ab954f4581944a$var$hasProcessEnv = typeof $e08gr !== "undefined" && typeof $e08gr.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $27ab954f4581944a$var$ENV_ENABLE_PLATFORM_FF = $27ab954f4581944a$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $27ab954f4581944a$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $27ab954f4581944a$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $27ab954f4581944a$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $27ab954f4581944a$var$ENV_ENABLE_PLATFORM_FF || $27ab954f4581944a$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $27ab954f4581944a$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $27ab954f4581944a$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$27ab954f4581944a$var$globalVar[$27ab954f4581944a$export$7e41b1b2bdee3f98] = $27ab954f4581944a$var$globalVar[$27ab954f4581944a$export$7e41b1b2bdee3f98] || $27ab954f4581944a$var$DEFAULT_PFF_GLOBAL;
function $27ab954f4581944a$export$f2b591175b3e424c(resolver) {
    $27ab954f4581944a$var$globalVar[$27ab954f4581944a$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $27ab954f4581944a$export$6333b6aff9fc6275(flagKey) {
    if ($27ab954f4581944a$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $eUsTo.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $27ab954f4581944a$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $27ab954f4581944a$var$globalVar[$27ab954f4581944a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $27ab954f4581944a$var$globalVar[$27ab954f4581944a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $kRYwT.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $27ab954f4581944a$var$globalVar[$27ab954f4581944a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("eUsTo", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $adacb518d1175659$export$1c9f709888824e05; });
var $adacb518d1175659$var$_process, $adacb518d1175659$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $adacb518d1175659$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($adacb518d1175659$var$_process = globalThis.process) === null || $adacb518d1175659$var$_process === void 0 || ($adacb518d1175659$var$_process = $adacb518d1175659$var$_process.env) === null || $adacb518d1175659$var$_process === void 0 ? void 0 : $adacb518d1175659$var$_process.JEST_WORKER_ID) !== undefined;
var $adacb518d1175659$var$DEBUG_MODE = !$adacb518d1175659$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($adacb518d1175659$var$_process2 = globalThis.process) === null || $adacb518d1175659$var$_process2 === void 0 || ($adacb518d1175659$var$_process2 = $adacb518d1175659$var$_process2.env) === null || $adacb518d1175659$var$_process2 === void 0 ? void 0 : $adacb518d1175659$var$_process2.NODE_ENV) !== "production";
var $adacb518d1175659$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$adacb518d1175659$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});




parcelRegister("c9Gcy", function(module, exports) {

$parcel$export(module.exports, "useCloseOnEscapePress", function () { return $8d970f9e03d59b97$export$4a4bf067ea9e7886; });
$parcel$export(module.exports, "useLayering", function () { return $8d970f9e03d59b97$export$c8b4d54e03dee6ed; });

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $aA6j8 = parcelRequire("aA6j8");

var $lehYd = parcelRequire("lehYd");

var $c284Y = parcelRequire("c284Y");
function $8d970f9e03d59b97$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8d970f9e03d59b97$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8d970f9e03d59b97$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8d970f9e03d59b97$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8d970f9e03d59b97$var$ESCAPE = "Escape";
function $8d970f9e03d59b97$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $91i6m.useRef)(false);
    var _useLayering = $8d970f9e03d59b97$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $91i6m.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $8d970f9e03d59b97$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $91i6m.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $91i6m.useEffect)(function() {
        return (0, $aA6j8.bindAll)(window, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $8d970f9e03d59b97$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $91i6m.useContext)((0, $c284Y.LevelContext));
    var _useContext = (0, $91i6m.useContext)((0, $c284Y.TopLevelContext)), topLevelRef = _useContext.topLevelRef, layerList = _useContext.layerList;
    var isLayerDisabled = (0, $91i6m.useCallback)(function() {
        if ((0, $lehYd.fg)("layering-top-level-use-array")) {
            var _layerList$current$le, _layerList$current;
            return ((_layerList$current$le = layerList === null || layerList === void 0 || (_layerList$current = layerList.current) === null || _layerList$current === void 0 ? void 0 : _layerList$current.length) !== null && _layerList$current$le !== void 0 ? _layerList$current$le : 0) !== currentLevel;
        }
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef,
        layerList
    ]);
    return $8d970f9e03d59b97$var$_objectSpread({
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    }, (0, $lehYd.fg)("layering-top-level-use-array") ? {
        layerList: layerList
    } : {});
}

});

parcelRegister("ckiKG", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $8f95e60a1379ea2a$export$badac9ada3a0bdf9; });

var $iqLBO = parcelRequire("iqLBO");

var $5YM7L = parcelRequire("5YM7L");

var $91i6m = parcelRequire("91i6m");

var $blZ6m = parcelRequire("blZ6m");

var $5f21r = parcelRequire("5f21r");

// Export types from PopperJS / React Popper
var $8f95e60a1379ea2a$var$viewportPadding = 5;
var $8f95e60a1379ea2a$var$constantModifiers = [
    {
        name: "flip",
        options: {
            flipVariations: false,
            padding: $8f95e60a1379ea2a$var$viewportPadding,
            boundary: "clippingParents",
            rootBoundary: "viewport"
        }
    }
];
function $8f95e60a1379ea2a$var$defaultChildrenFn() {
    return null;
}
var $8f95e60a1379ea2a$var$defaultOffset = [
    0,
    8
];
function $8f95e60a1379ea2a$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $8f95e60a1379ea2a$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $8f95e60a1379ea2a$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $91i6m.useMemo)(function() {
        var preventOverflowModifier = {
            name: "preventOverflow",
            options: {
                padding: $8f95e60a1379ea2a$var$viewportPadding,
                rootBoundary: shouldFitViewport ? "viewport" : "document"
            }
        };
        var offsetModifier = {
            name: "offset",
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $5f21r.getMaxSizeModifiers)({
            viewportPadding: $8f95e60a1379ea2a$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($8f95e60a1379ea2a$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $91i6m.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $blZ6m.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("5f21r", function(module, exports) {

$parcel$export(module.exports, "getMaxSizeModifiers", function () { return $3d0fec0b52b57c2a$export$6d8c2b45c99d6e3f; });

var $5YM7L = parcelRequire("5YM7L");
function $3d0fec0b52b57c2a$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: "maxSizeData",
            enabled: true,
            phase: "read",
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: "maxSize",
            enabled: true,
            phase: "beforeWrite",
            requiresIfExists: [
                "offset",
                "preventOverflow",
                "flip"
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== "number" || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== "number") // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split("-"), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === "top") maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === "bottom") maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === "left") maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === "right") maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}

});


parcelRegister("3r4d1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $280728882995e0e7$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $8zYGN = parcelRequire("8zYGN");
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {(instance: HTMLDivElement) => void} props.innerRef - A ref callback to get the instance of the HTMLDivElement.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
 */ var $280728882995e0e7$var$NodeResolverWrapper = function NodeResolverWrapper(_ref) {
    var hasNodeResolver = _ref.hasNodeResolver, children = _ref.children, innerRef = _ref.innerRef;
    if (hasNodeResolver) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8zYGN))), {
        innerRef: innerRef
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("div", {
        ref: function ref(node) {
            innerRef(node === null || node === void 0 ? void 0 : node.firstElementChild);
        }
    }, children);
};
var $280728882995e0e7$export$2e2bcd8739ae039 = $280728882995e0e7$var$NodeResolverWrapper;

});
parcelRegister("8zYGN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5mntL = parcelRequire("5mntL");
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $63f0ab39d635284e$var$_interopRequireDefault($5mntL).default;
    }
});
function $63f0ab39d635284e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("5mntL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $3e71384d61f9bcfc$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $91i6m = parcelRequire("91i6m");

var $eAqbf = parcelRequire("eAqbf");
function $3e71384d61f9bcfc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3e71384d61f9bcfc$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $3e71384d61f9bcfc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $3e71384d61f9bcfc$var$NodeResolver = function(_Component) {
    $3e71384d61f9bcfc$var$_inherits(NodeResolver, _Component);
    function NodeResolver() {
        $3e71384d61f9bcfc$var$_classCallCheck(this, NodeResolver);
        return $3e71384d61f9bcfc$var$_possibleConstructorReturn(this, (NodeResolver.__proto__ || Object.getPrototypeOf(NodeResolver)).apply(this, arguments));
    }
    $3e71384d61f9bcfc$var$_createClass(NodeResolver, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.props.innerRef((0, $eAqbf.findDOMNode)(this));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.props.innerRef(null);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return NodeResolver;
}($91i6m.Component);
module.exports.default = $3e71384d61f9bcfc$var$NodeResolver;

});



parcelRegister("1aQVR", function(module, exports) {

$parcel$export(module.exports, "Container", function () { return $0dafc8dc33dff8b5$export$42a852a2b6b56249; });
/* container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
var $5oJNc = parcelRequire("5oJNc");

var $kjFtK = parcelRequire("kjFtK");
function $0dafc8dc33dff8b5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0dafc8dc33dff8b5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0dafc8dc33dff8b5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0dafc8dc33dff8b5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0dafc8dc33dff8b5$var$CSS_THEME_BACKGROUND = "--theme-background";
var $0dafc8dc33dff8b5$var$CSS_THEME_COLOR = "--theme-color";
var $0dafc8dc33dff8b5$var$CSS_THEME_BOX_SHADOW = "--theme-box-shadow";
var $0dafc8dc33dff8b5$var$containerStyles = null;
var $0dafc8dc33dff8b5$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
    var children = _ref.children, onBlur = _ref.onBlur, onClick = _ref.onClick, onFocus = _ref.onFocus, style = _ref.style, testId = _ref.testId;
    return /*#__PURE__*/ $91i6m.createElement("div", {
        "data-testid": testId,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        ref: ref,
        className: (0, $9gzWK.default)([
            "_11q717w6 _2rko1sit _vchh1ntv _p12f184t _c71l184t _1pbyowjs _16qs11gm _syaz1xgh _85i5pxbi _1q51pxbi _y4ti1ejb _bozg1ejb _nt751r31 _49pcglyw _1hvw1o36"
        ]),
        style: $0dafc8dc33dff8b5$var$_objectSpread($0dafc8dc33dff8b5$var$_objectSpread({}, $0dafc8dc33dff8b5$var$_objectSpread((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, $0dafc8dc33dff8b5$var$CSS_THEME_BACKGROUND, "var(--ds-surface-overlay, ".concat((0, $kjFtK.N0), ")")), $0dafc8dc33dff8b5$var$CSS_THEME_COLOR, "var(--ds-text, ".concat((0, $kjFtK.N900), ")")), $0dafc8dc33dff8b5$var$CSS_THEME_BOX_SHADOW, "var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat((0, $kjFtK.N50A), ", 0 0 1px ").concat((0, $kjFtK.N60A)), ")")), style)), {}, {
            "--_n6nwya": (0, $5oJNc.default)("".concat(448, "px")),
            "--_902zhz": (0, $5oJNc.default)("var(".concat($0dafc8dc33dff8b5$var$CSS_THEME_BACKGROUND, ")")),
            "--_uojrza": (0, $5oJNc.default)("var(".concat($0dafc8dc33dff8b5$var$CSS_THEME_BOX_SHADOW, ")")),
            "--_1yif2ym": (0, $5oJNc.default)("var(".concat($0dafc8dc33dff8b5$var$CSS_THEME_COLOR, ")"))
        })
    }, typeof children === "function" ? children() : children);
});

});
parcelRegister("kjFtK", function(module, exports) {

$parcel$export(module.exports, "N0", function () { return $eca5c1d0ba446500$export$29a4f05edc054374; });
$parcel$export(module.exports, "N900", function () { return $eca5c1d0ba446500$export$fbda843f0a27fe96; });
$parcel$export(module.exports, "N50A", function () { return $eca5c1d0ba446500$export$7d3359664e8bb0e5; });
$parcel$export(module.exports, "N60A", function () { return $eca5c1d0ba446500$export$d2d3bedfb276cac0; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $eca5c1d0ba446500$export$4b84fd0e2c617bd = "#FFEBE6";
var $eca5c1d0ba446500$export$b34b069eff244586 = "#FFBDAD";
var $eca5c1d0ba446500$export$be802dd0d8b57f35 = "#FF8F73";
var $eca5c1d0ba446500$export$60847d42f9da92a6 = "#FF7452";
var $eca5c1d0ba446500$export$4a7404f376229999 = "#FF5630";
var $eca5c1d0ba446500$export$2010d0fb4295b346 = "#DE350B";
var $eca5c1d0ba446500$export$2837b5a1a71d5c02 = "#BF2600";
var $eca5c1d0ba446500$export$8d9596b529bbb9cf = "#FFFAE6";
var $eca5c1d0ba446500$export$41060a744ab0b7ae = "#FFF0B3";
var $eca5c1d0ba446500$export$1cc05bbbf340e559 = "#FFE380";
var $eca5c1d0ba446500$export$5aae31392d72caaa = "#FFC400";
var $eca5c1d0ba446500$export$c6930421db9fa514 = "#FFAB00";
var $eca5c1d0ba446500$export$59619663aa6500fb = "#FF991F";
var $eca5c1d0ba446500$export$874739ea9e379ab6 = "#FF8B00";
var $eca5c1d0ba446500$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $eca5c1d0ba446500$export$69a3bf21b9686c2b = "#ABF5D1";
var $eca5c1d0ba446500$export$afbce1382ec95f73 = "#79F2C0";
var $eca5c1d0ba446500$export$747d86715d4175de = "#57D9A3";
var $eca5c1d0ba446500$export$940e1f69e873f202 = "#36B37E";
var $eca5c1d0ba446500$export$a49394138f7b8e85 = "#00875A";
var $eca5c1d0ba446500$export$6fa04827ac68a4fb = "#006644";
var $eca5c1d0ba446500$export$226de0355ed012f8 = "#DEEBFF";
var $eca5c1d0ba446500$export$8c13c2ee36917869 = "#B3D4FF";
var $eca5c1d0ba446500$export$ecfc1dff386a3e7a = "#4C9AFF";
var $eca5c1d0ba446500$export$215b7063051591f1 = "#2684FF";
var $eca5c1d0ba446500$export$e62e8919cca44969 = "#0065FF";
var $eca5c1d0ba446500$export$b3de0ae08da2ce64 = "#0052CC";
var $eca5c1d0ba446500$export$a6ee3d71bc067634 = "#0747A6";
var $eca5c1d0ba446500$export$67f15409e87642a1 = "#669DF1";
var $eca5c1d0ba446500$export$f0539dbc42dbb067 = "#8FB8F6";
var $eca5c1d0ba446500$export$363e4475840015bb = "#EAE6FF";
var $eca5c1d0ba446500$export$4b0a4417ed59760f = "#C0B6F2";
var $eca5c1d0ba446500$export$6011520a64d9a187 = "#998DD9";
var $eca5c1d0ba446500$export$a7175d4e9206bc80 = "#8777D9";
var $eca5c1d0ba446500$export$b48405b95304b5a1 = "#6554C0";
var $eca5c1d0ba446500$export$c71e4279dd54a18d = "#5243AA";
var $eca5c1d0ba446500$export$147899de772240ec = "#403294";
var $eca5c1d0ba446500$export$2cf711fe14c66f06 = "#E6FCFF";
var $eca5c1d0ba446500$export$7a8f4d33f6f9772c = "#B3F5FF";
var $eca5c1d0ba446500$export$776c9c497ef08533 = "#79E2F2";
var $eca5c1d0ba446500$export$69cb3ca10c1e330e = "#00C7E6";
var $eca5c1d0ba446500$export$9dc1ef0f3f48059b = "#00B8D9";
var $eca5c1d0ba446500$export$7c835c78b6fcdef8 = "#00A3BF";
var $eca5c1d0ba446500$export$6036577f95c3877e = "#008DA6";
var $eca5c1d0ba446500$export$29a4f05edc054374 = "#FFFFFF";
var $eca5c1d0ba446500$export$e655ef011c4aa1a2 = "#FAFBFC";
var $eca5c1d0ba446500$export$9fdfb749e33cdf97 = "#F4F5F7";
var $eca5c1d0ba446500$export$3e51e8f1440314ba = "#EBECF0";
var $eca5c1d0ba446500$export$1ce2d1575d444ceb = "#DFE1E6";
var $eca5c1d0ba446500$export$8754fc7e6d8b3000 = "#C1C7D0";
var $eca5c1d0ba446500$export$c2e91cbeada39b8b = "#B3BAC5";
var $eca5c1d0ba446500$export$5f71e19f3a7ad9de = "#A5ADBA";
var $eca5c1d0ba446500$export$eaa8c8a70ac22806 = "#97A0AF";
var $eca5c1d0ba446500$export$7c87d337fb91a97d = "#8993A4";
var $eca5c1d0ba446500$export$d6447c357493214f = "#7A869A";
var $eca5c1d0ba446500$export$f563ee71e9ee74cd = "#6B778C";
var $eca5c1d0ba446500$export$e2ef2124cf4024b1 = "#5E6C84";
var $eca5c1d0ba446500$export$eece5f492e429f08 = "#505F79";
var $eca5c1d0ba446500$export$c39c0fe0f26207ae = "#42526E";
var $eca5c1d0ba446500$export$7090862dc3038a9f = "#344563";
var $eca5c1d0ba446500$export$ad0bacf983b7ddaa = "#253858";
var $eca5c1d0ba446500$export$7d61b15e0da132af = "#172B4D";
var $eca5c1d0ba446500$export$fbda843f0a27fe96 = "#091E42";
var $eca5c1d0ba446500$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $eca5c1d0ba446500$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $eca5c1d0ba446500$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $eca5c1d0ba446500$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $eca5c1d0ba446500$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $eca5c1d0ba446500$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $eca5c1d0ba446500$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $eca5c1d0ba446500$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $eca5c1d0ba446500$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $eca5c1d0ba446500$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $eca5c1d0ba446500$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $eca5c1d0ba446500$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $eca5c1d0ba446500$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $eca5c1d0ba446500$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $eca5c1d0ba446500$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $eca5c1d0ba446500$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $eca5c1d0ba446500$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $eca5c1d0ba446500$export$2f6319cf7d736c2a = "#E6EDFA";
var $eca5c1d0ba446500$export$95126bc8884d6634 = "#DCE5F5";
var $eca5c1d0ba446500$export$8338d8c35d44ff1 = "#CED9EB";
var $eca5c1d0ba446500$export$5368d76ae4fbbda7 = "#B8C7E0";
var $eca5c1d0ba446500$export$9f0a771d16ec8d36 = "#ABBBD6";
var $eca5c1d0ba446500$export$abcf8c38338b4aa5 = "#9FB0CC";
var $eca5c1d0ba446500$export$97e81faa16a182c7 = "#8C9CB8";
var $eca5c1d0ba446500$export$bfe21c59123ecf33 = "#7988A3";
var $eca5c1d0ba446500$export$ee82aa2ea6a1558 = "#67758F";
var $eca5c1d0ba446500$export$682927c6ed76be02 = "#56637A";
var $eca5c1d0ba446500$export$91fd9994c5be9757 = "#455166";
var $eca5c1d0ba446500$export$d281fbfe3cff2df6 = "#3B475C";
var $eca5c1d0ba446500$export$3902c91d8b98a753 = "#313D52";
var $eca5c1d0ba446500$export$8e8133c1ba5845b5 = "#283447";
var $eca5c1d0ba446500$export$33ff357f6620b39 = "#202B3D";
var $eca5c1d0ba446500$export$633847cf062b69e0 = "#1B2638";
var $eca5c1d0ba446500$export$9776a6e503bdbf76 = "#121A29";
var $eca5c1d0ba446500$export$6c813d5160dff5db = "#0E1624";
var $eca5c1d0ba446500$export$3d4f271a500072a = "#0D1424";
var $eca5c1d0ba446500$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $eca5c1d0ba446500$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $eca5c1d0ba446500$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $eca5c1d0ba446500$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $eca5c1d0ba446500$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $eca5c1d0ba446500$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $eca5c1d0ba446500$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $eca5c1d0ba446500$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $eca5c1d0ba446500$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $eca5c1d0ba446500$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $eca5c1d0ba446500$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $eca5c1d0ba446500$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $eca5c1d0ba446500$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $eca5c1d0ba446500$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $eca5c1d0ba446500$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $eca5c1d0ba446500$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $eca5c1d0ba446500$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $eca5c1d0ba446500$export$d2adc5dedf09fced = "#292A2E";
var $eca5c1d0ba446500$export$f51762073d2bb381 = "#94C748";
var $eca5c1d0ba446500$export$95e26d54def96891 = "#B3DF72";

});



parcelRegister("cS1ZL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95ec135c425b8d49$export$2e2bcd8739ae039; });
/* inline.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $da7Sb = parcelRequire("da7Sb");

var $7GFmP = parcelRequire("7GFmP");
var $95ec135c425b8d49$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $95ec135c425b8d49$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $91i6m.createElement("span", {
        className: (0, $9gzWK.default)([
            $95ec135c425b8d49$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $95ec135c425b8d49$var$Inline = /*#__PURE__*/ (0, $91i6m.memo)(/*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? /*#__PURE__*/ $91i6m.createElement($95ec135c425b8d49$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $91i6m.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $91i6m.createElement((0, $91i6m.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $91i6m.createElement((0, $7GFmP.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: (0, $da7Sb.cx)(grow === "hug" && $95ec135c425b8d49$var$styles.hug, grow === "fill" && $95ec135c425b8d49$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }, children);
}));
$95ec135c425b8d49$var$Inline.displayName = "Inline";
var $95ec135c425b8d49$export$2e2bcd8739ae039 = $95ec135c425b8d49$var$Inline;

});
parcelRegister("7GFmP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $598c8b5520f4ab90$export$2e2bcd8739ae039; });
/* flex.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");
var $598c8b5520f4ab90$var$rowGapMap = {
    "space.0": "_1p57ze3t",
    "space.025": "_1p57v77o",
    "space.050": "_1p571b66",
    "space.075": "_1p5712x7",
    "space.100": "_1p57u2gc",
    "space.150": "_1p57utpp",
    "space.200": "_1p57pxbi",
    "space.250": "_1p57v47k",
    "space.300": "_1p571ejb",
    "space.400": "_1p57xy5q",
    "space.500": "_1p571jfw",
    "space.600": "_1p57oahv",
    "space.800": "_1p57xncg",
    "space.1000": "_1p571epz"
};
var $598c8b5520f4ab90$var$columnGapMap = {
    "space.0": "_gy1pze3t",
    "space.025": "_gy1pv77o",
    "space.050": "_gy1p1b66",
    "space.075": "_gy1p12x7",
    "space.100": "_gy1pu2gc",
    "space.150": "_gy1putpp",
    "space.200": "_gy1ppxbi",
    "space.250": "_gy1pv47k",
    "space.300": "_gy1p1ejb",
    "space.400": "_gy1pxy5q",
    "space.500": "_gy1p1jfw",
    "space.600": "_gy1poahv",
    "space.800": "_gy1pxncg",
    "space.1000": "_gy1p1epz"
};
var $598c8b5520f4ab90$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    "space-between": "_1bah1yb4",
    "space-around": "_1bah1b1v",
    "space-evenly": "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $598c8b5520f4ab90$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $598c8b5520f4ab90$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $598c8b5520f4ab90$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $598c8b5520f4ab90$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $598c8b5520f4ab90$var$Flex = /*#__PURE__*/ (0, $91i6m.memo)(/*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    return /*#__PURE__*/ $91i6m.createElement(Component, {
        role: role,
        className: (0, $9gzWK.default)([
            $598c8b5520f4ab90$var$styles.root,
            gap && $598c8b5520f4ab90$var$columnGapMap[gap],
            columnGap && $598c8b5520f4ab90$var$columnGapMap[columnGap],
            gap && $598c8b5520f4ab90$var$rowGapMap[gap],
            rowGap && $598c8b5520f4ab90$var$rowGapMap[rowGap],
            alignItems && $598c8b5520f4ab90$var$alignItemsMap[alignItems],
            direction && $598c8b5520f4ab90$var$flexDirectionMap[direction],
            justifyContent && $598c8b5520f4ab90$var$justifyContentMap[justifyContent],
            wrap && $598c8b5520f4ab90$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$598c8b5520f4ab90$var$Flex.displayName = "Flex";
var $598c8b5520f4ab90$export$2e2bcd8739ae039 = $598c8b5520f4ab90$var$Flex;

});


parcelRegister("gMobs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c373e36c0c532ec8$export$2e2bcd8739ae039; });
/* text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");

var $24QNd = parcelRequire("24QNd");

var $1poiC = parcelRequire("1poiC");

var $lWDTa = parcelRequire("lWDTa");
var $c373e36c0c532ec8$var$asAllowlist = [
    "span",
    "p",
    "strong",
    "em"
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $c373e36c0c532ec8$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $lWDTa.useSurface)();
    if (colorProp === "inherit") return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($c373e36c0c532ec8$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $c373e36c0c532ec8$export$2185ce37f9bdd963[surface];
    return "color.text";
};
var $c373e36c0c532ec8$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    "as.strong": "_k48pmoej",
    "as.em": "_zg8l1m30",
    "textAlign.center": "_y3gn1h6o",
    "textAlign.end": "_y3gnh9n0",
    "textAlign.start": "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $c373e36c0c532ec8$var$fontSizeMap = {
    medium: "_11c82smr",
    UNSAFE_small: "_11c8dcr7",
    large: "_11c81ixg",
    small: "_11c81o8v"
};
var $c373e36c0c532ec8$var$fontWeightMap = {
    bold: "_k48pmoej",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $c373e36c0c532ec8$var$textColorMap = {
    "color.text": "_syaz1fxt",
    "color.text.accent.lime": "_syaz1tco",
    "color.text.accent.lime.bolder": "_syaz1ik3",
    "color.text.accent.red": "_syaz9lu1",
    "color.text.accent.red.bolder": "_syazhwvp",
    "color.text.accent.orange": "_syaz1q28",
    "color.text.accent.orange.bolder": "_syaz1vps",
    "color.text.accent.yellow": "_syazfb2s",
    "color.text.accent.yellow.bolder": "_syazekll",
    "color.text.accent.green": "_syazh55r",
    "color.text.accent.green.bolder": "_syaz1y78",
    "color.text.accent.teal": "_syaz17qg",
    "color.text.accent.teal.bolder": "_syaz12v7",
    "color.text.accent.blue": "_syazpnps",
    "color.text.accent.blue.bolder": "_syazsc1o",
    "color.text.accent.purple": "_syaz10m5",
    "color.text.accent.purple.bolder": "_syaz2ibx",
    "color.text.accent.magenta": "_syaz1s8m",
    "color.text.accent.magenta.bolder": "_syaz1qur",
    "color.text.accent.gray": "_syaz1dyx",
    "color.text.accent.gray.bolder": "_syaz1x9z",
    "color.text.disabled": "_syaz1lh4",
    "color.text.inverse": "_syaz15cr",
    "color.text.selected": "_syazaqb7",
    "color.text.brand": "_syaz1e6v",
    "color.text.danger": "_syaz1tmw",
    "color.text.warning": "_syazwx40",
    "color.text.warning.inverse": "_syazal3n",
    "color.text.success": "_syazy73q",
    "color.text.discovery": "_syazzjem",
    "color.text.information": "_syaze0os",
    "color.text.subtlest": "_syaz131l",
    "color.text.subtle": "_syaz1gjq",
    "color.link": "_syaz14q2",
    "color.link.pressed": "_syaz16c2",
    "color.link.visited": "_syazw7te",
    "color.link.visited.pressed": "_syazg3x0"
};
var $c373e36c0c532ec8$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $c373e36c0c532ec8$var$Text = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "span" : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $24QNd.default)($c373e36c0c532ec8$var$asAllowlist.includes(Component), '@atlaskit/primitives: Text received an invalid "as" value of "'.concat(Component, '"'));
    var hasTextAncestor = (0, $1poiC.useHasTextAncestor)();
    var color = $c373e36c0c532ec8$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = "medium";
    var component = /*#__PURE__*/ $91i6m.createElement(Component, {
        id: id,
        className: (0, $9gzWK.default)([
            $c373e36c0c532ec8$var$styles.root,
            size && $c373e36c0c532ec8$var$fontSizeMap[size],
            color && $c373e36c0c532ec8$var$textColorMap[color],
            maxLines && $c373e36c0c532ec8$var$styles.truncation,
            maxLines === 1 && $c373e36c0c532ec8$var$styles.breakAll,
            align && $c373e36c0c532ec8$var$styles["textAlign.".concat(align)],
            weight && $c373e36c0c532ec8$var$fontWeightMap[weight],
            Component === "em" && $c373e36c0c532ec8$var$styles["as.em"],
            Component === "strong" && $c373e36c0c532ec8$var$styles["as.strong"],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $91i6m.createElement((0, $1poiC.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $c373e36c0c532ec8$export$2e2bcd8739ae039 = $c373e36c0c532ec8$var$Text;

});
parcelRegister("1poiC", function(module, exports) {

$parcel$export(module.exports, "useHasTextAncestor", function () { return $106af993aa89bed2$export$9322276ec105d055; });
$parcel$export(module.exports, "HasTextAncestorProvider", function () { return $106af993aa89bed2$export$ae933c6cbe5643ad; });

var $91i6m = parcelRequire("91i6m");
var $106af993aa89bed2$var$HasTextAncestorContext = /*#__PURE__*/ (0, $91i6m.createContext)(false);
var $106af993aa89bed2$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $91i6m.useContext)($106af993aa89bed2$var$HasTextAncestorContext);
};
var $106af993aa89bed2$export$ae933c6cbe5643ad = $106af993aa89bed2$var$HasTextAncestorContext.Provider;

});

parcelRegister("lWDTa", function(module, exports) {

$parcel$export(module.exports, "useSurface", function () { return $ff9df4d655eaa2a4$export$1aeb4f6b93c4540d; });

var $91i6m = parcelRequire("91i6m");
var $ff9df4d655eaa2a4$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $91i6m.createContext)("elevation.surface");
var $ff9df4d655eaa2a4$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $91i6m.useContext)($ff9df4d655eaa2a4$export$1ca2a26fecb070ae);
};
$ff9df4d655eaa2a4$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});


parcelRegister("7xwGT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57d4f92eecd99af5$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91i6m = parcelRequire("91i6m");

var $9gzWK = parcelRequire("9gzWK");


var $dmZfh = parcelRequire("dmZfh");
var $57d4f92eecd99af5$var$iconColor = {
    connectivity: "_1b3i1c86",
    confirmation: "_1b3icdx1",
    info: "_1b3ige5s",
    warning: "_1b3i1n6p",
    error: "_1b3i1378"
};
var $57d4f92eecd99af5$var$iconWrapperStyles = null;
var $57d4f92eecd99af5$var$iconColorStyles = null;
/**
 * __Selected icon__
 *
 * The selected icon is used as the primary interactive element for the dialog.
 * Can be used with or without supporting text.
 */ var $57d4f92eecd99af5$var$SelectedIcon = function SelectedIcon(_ref) {
    var appearance = _ref.appearance, isOpen = _ref.isOpen, label = _ref.label;
    var _typesMapping$appeara = (0, $dmZfh.typesMapping)[appearance], Icon = _typesMapping$appeara.icon, defaultLabel = _typesMapping$appeara.defaultLabel;
    return /*#__PURE__*/ $91i6m.createElement("span", {
        "data-ds--inline-message--icon": true,
        className: (0, $9gzWK.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o _syazkr0v",
            isOpen && "_syaz1kum",
            $57d4f92eecd99af5$var$iconColor[appearance]
        ])
    }, /*#__PURE__*/ $91i6m.createElement(Icon, {
        testId: "inline-message-icon",
        label: label || defaultLabel,
        color: "currentColor",
        LEGACY_size: "medium",
        spacing: "spacious"
    }));
};
var $57d4f92eecd99af5$export$2e2bcd8739ae039 = $57d4f92eecd99af5$var$SelectedIcon;

});
parcelRegister("dmZfh", function(module, exports) {

$parcel$export(module.exports, "typesMapping", function () { return $9bbcd67eeca923c1$export$4d111645c0b39d5d; });

var $3SaMA = parcelRequire("3SaMA");

var $9aJr5 = parcelRequire("9aJr5");

var $kL1TI = parcelRequire("kL1TI");

var $d8mmy = parcelRequire("d8mmy");
var $9bbcd67eeca923c1$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d8mmy))),
        defaultLabel: "connectivity inline message"
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kL1TI))),
        defaultLabel: "confirmation inline message"
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9aJr5))),
        defaultLabel: "info inline message"
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d8mmy))),
        defaultLabel: "warning inline message"
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3SaMA))),
        defaultLabel: "error inline message"
    }
};

});
parcelRegister("3SaMA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a36a65999ae3c13d3a1917b5e2b052e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2d1ec77917227684$var$_react = $2d1ec77917227684$var$_interopRequireDefault((parcelRequire("91i6m")));

var $2d1ec77917227684$var$_error = $2d1ec77917227684$var$_interopRequireDefault((parcelRequire("lMFTs")));

var $2d1ec77917227684$var$_error2 = $2d1ec77917227684$var$_interopRequireDefault((parcelRequire("i3tDa")));
function $2d1ec77917227684$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2d1ec77917227684$var$ErrorIcon = (props)=>/*#__PURE__*/ $2d1ec77917227684$var$_react.default.createElement($2d1ec77917227684$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $2d1ec77917227684$var$_error2.default
    }, props));
$2d1ec77917227684$var$ErrorIcon.Name = "ErrorIconMigration";
var $2d1ec77917227684$var$_default = module.exports.default = $2d1ec77917227684$var$ErrorIcon;

});
parcelRegister("lMFTs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::257fef37d04db299e24e95484ff9b12f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fdbe93d9d33c62d2$var$_react = $fdbe93d9d33c62d2$var$_interopRequireDefault((parcelRequire("91i6m")));

var $fdbe93d9d33c62d2$var$_baseNew = $fdbe93d9d33c62d2$var$_interopRequireDefault((parcelRequire("aae9A")));
function $fdbe93d9d33c62d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Error".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fdbe93d9d33c62d2$var$ErrorIcon = (props)=>/*#__PURE__*/ $fdbe93d9d33c62d2$var$_react.default.createElement($fdbe93d9d33c62d2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.604a2 2 0 0 1 2.828 0l5.982 5.982a2 2 0 0 1 0 2.828l-5.982 5.983a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM7.25 9V3.75h1.5V9zM8 12.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$fdbe93d9d33c62d2$var$ErrorIcon.displayName = "ErrorIcon";
var $fdbe93d9d33c62d2$var$_default = module.exports.default = $fdbe93d9d33c62d2$var$ErrorIcon;

});
parcelRegister("aae9A", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("c4U1D")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("c4U1D")).Icon; });

var $c4U1D = parcelRequire("c4U1D");

});
parcelRegister("c4U1D", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $8cb151340680f520$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $8cb151340680f520$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $91i6m = parcelRequire("91i6m");

var $lPOF7 = parcelRequire("lPOF7");

var $cqLfB = parcelRequire("cqLfB");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $8cb151340680f520$var$commonSVGStyles = (0, $lPOF7.css)({
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: "currentColor"
    }
});
var $8cb151340680f520$var$svgStyles = (0, $lPOF7.css)({
    color: "currentColor",
    verticalAlign: "bottom"
});
var $8cb151340680f520$var$iconStyles = (0, $lPOF7.css)({
    display: "inline-block",
    boxSizing: "border-box",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    paddingInlineEnd: "var(--ds--button--new-icon-padding-end, 0)",
    paddingInlineStart: "var(--ds--button--new-icon-padding-start, 0)"
});
var $8cb151340680f520$var$utilityIconStyles = (0, $lPOF7.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-150, 12px)"
});
var $8cb151340680f520$var$scaleStyles = (0, $lPOF7.css)({
    width: "inherit",
    height: "inherit"
});
/**
 * For windows high contrast mode
 */ var $8cb151340680f520$var$baseHcmStyles = (0, $lPOF7.css)({
    "@media screen and (forced-colors: active)": {
        color: "CanvasText",
        filter: "grayscale(1)"
    }
});
var $8cb151340680f520$var$scaleSize = (0, $lPOF7.css)({
    width: "inherit",
    height: "inherit"
});
var $8cb151340680f520$var$sizeMap = {
    core: {
        none: (0, $lPOF7.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $lPOF7.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $lPOF7.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $lPOF7.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $lPOF7.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $8cb151340680f520$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $8cb151340680f520$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $8cb151340680f520$export$f04a61298a47a40f = /*#__PURE__*/ (0, $91i6m.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $cqLfB.fg)("platform-visual-refresh-icons")) // parse out unnecessary props
    return (0, $lPOF7.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $8cb151340680f520$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : "core"];
    var viewBoxPadding;
    if (props.type === "utility") {
        var _props$spacing;
        viewBoxPadding = $8cb151340680f520$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : "none"];
    } else {
        var _props$spacing2;
        viewBoxPadding = $8cb151340680f520$var$paddingMap["core"][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : "none"];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return (0, $lPOF7.jsx)("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        css: [
            $8cb151340680f520$var$iconStyles,
            $8cb151340680f520$var$baseHcmStyles,
            shouldScale && $8cb151340680f520$var$scaleStyles,
            props.type === "utility" && $8cb151340680f520$var$utilityIconStyles
        ]
    }, (0, $lPOF7.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $8cb151340680f520$var$commonSVGStyles,
            $8cb151340680f520$var$svgStyles,
            shouldScale ? $8cb151340680f520$var$scaleSize : props.type === "utility" ? $8cb151340680f520$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : "none"] : $8cb151340680f520$var$sizeMap["core"][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : "none"]
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $8cb151340680f520$export$2e2bcd8739ae039 = $8cb151340680f520$export$f04a61298a47a40f;

});



parcelRegister("i3tDa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d24f7dd986d90fc6$var$_react = $d24f7dd986d90fc6$var$_interopRequireDefault((parcelRequire("91i6m")));

var $el0Nf = parcelRequire("el0Nf");

var $d24f7dd986d90fc6$var$_error = $d24f7dd986d90fc6$var$_interopRequireDefault((parcelRequire("lMFTs")));
function $d24f7dd986d90fc6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d24f7dd986d90fc6$var$ErrorIcon = (props)=>/*#__PURE__*/ $d24f7dd986d90fc6$var$_react.default.createElement($el0Nf.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $d24f7dd986d90fc6$var$_error.default
    }));
$d24f7dd986d90fc6$var$ErrorIcon.displayName = "ErrorIcon";
var $d24f7dd986d90fc6$var$_default = module.exports.default = $d24f7dd986d90fc6$var$ErrorIcon;

});
parcelRegister("el0Nf", function(module, exports) {

$parcel$export(module.exports, "IconFacade", function () { return $a703a45dff3118e6$export$3cfb73f70dfca966; });

var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $cqLfB = parcelRequire("cqLfB");

var $kp3ZG = parcelRequire("kp3ZG");
var $a703a45dff3118e6$var$_excluded = [
    "dangerouslySetGlyph"
];
var $a703a45dff3118e6$var$sizeSpacingMap = {
    utility: {
        small: "compact",
        medium: "spacious"
    },
    core: {
        small: "none",
        medium: "spacious"
    }
};
var $a703a45dff3118e6$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $91i6m.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $a703a45dff3118e6$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : "medium";
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $cqLfB.fg)("platform-visual-refresh-icons-legacy-facade");
    if (useNewIcon && NewIcon && (size === "small" || size === "medium")) {
        if (props.iconType === "utility") {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, props, {
                spacing: (0, $cqLfB.fg)("platform-visual-refresh-icons-facade-button-fix") ? $a703a45dff3118e6$var$sizeSpacingMap["utility"][size] : "none",
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, props, {
                spacing: $a703a45dff3118e6$var$sizeSpacingMap["core"][size],
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $kp3ZG.Icon), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});

});
parcelRegister("kp3ZG", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $eda93d8dd7e1ac8d$export$f04a61298a47a40f; });

var $cIDQN = parcelRequire("cIDQN");

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $lPOF7 = parcelRequire("lPOF7");

var $4jWPX = parcelRequire("4jWPX");

var $kHoOm = parcelRequire("kHoOm");
function $eda93d8dd7e1ac8d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $eda93d8dd7e1ac8d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $eda93d8dd7e1ac8d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $eda93d8dd7e1ac8d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $eda93d8dd7e1ac8d$var$iconStyles = (0, $lPOF7.css)({
    display: "inline-block",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> svg": $eda93d8dd7e1ac8d$var$_objectSpread($eda93d8dd7e1ac8d$var$_objectSpread({}, (0, $4jWPX.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $eda93d8dd7e1ac8d$var$baseHcmStyles = (0, $lPOF7.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $eda93d8dd7e1ac8d$var$primaryEqualsSecondaryHcmStyles = (0, $lPOF7.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $eda93d8dd7e1ac8d$var$secondaryTransparentHcmStyles = (0, $lPOF7.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $eda93d8dd7e1ac8d$export$f04a61298a47a40f = /*#__PURE__*/ (0, $91i6m.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $lPOF7.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $4jWPX.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $lPOF7.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor || (0, $kHoOm.getBackground)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        }
    }, glyphProps, {
        css: [
            $eda93d8dd7e1ac8d$var$iconStyles,
            $eda93d8dd7e1ac8d$var$baseHcmStyles,
            primaryColor === secondaryColor && $eda93d8dd7e1ac8d$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $eda93d8dd7e1ac8d$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $lPOF7.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                "> svg": dimensions
            })
        ]
    }));
});
var $eda93d8dd7e1ac8d$export$2e2bcd8739ae039 = $eda93d8dd7e1ac8d$export$f04a61298a47a40f;

});
parcelRegister("4jWPX", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", function () { return $3256939452df5606$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $3256939452df5606$export$3eb7d6130acfda37; });

var $k2FO5 = parcelRequire("k2FO5");

var $lPOF7 = parcelRequire("lPOF7");
var $3256939452df5606$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $3256939452df5606$var$smallStyles = (0, $lPOF7.css)((0, $k2FO5.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $3256939452df5606$var$mediumStyles = (0, $lPOF7.css)((0, $k2FO5.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $3256939452df5606$var$largeStyles = (0, $lPOF7.css)((0, $k2FO5.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $3256939452df5606$var$xlargeStyles = (0, $lPOF7.css)((0, $k2FO5.dimensions).xlarge);
var $3256939452df5606$export$ef0ad74202575b64 = {
    small: $3256939452df5606$var$smallStyles,
    medium: $3256939452df5606$var$mediumStyles,
    large: $3256939452df5606$var$largeStyles,
    xlarge: $3256939452df5606$var$xlargeStyles
};
var $3256939452df5606$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $k2FO5.dimensions)[size];
    return undefined;
};

});
parcelRegister("k2FO5", function(module, exports) {

$parcel$export(module.exports, "dimensions", function () { return $e9746c8bab687c5e$export$62ad7b0c781000e9; });
var $e9746c8bab687c5e$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $e9746c8bab687c5e$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $e9746c8bab687c5e$export$62ad7b0c781000e9 = {
    small: {
        width: $e9746c8bab687c5e$export$c647cb0ee6e282fe.small,
        height: $e9746c8bab687c5e$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $e9746c8bab687c5e$export$c647cb0ee6e282fe.medium,
        height: $e9746c8bab687c5e$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $e9746c8bab687c5e$export$c647cb0ee6e282fe.large,
        height: $e9746c8bab687c5e$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $e9746c8bab687c5e$export$c647cb0ee6e282fe.xlarge,
        height: $e9746c8bab687c5e$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("kHoOm", function(module, exports) {

$parcel$export(module.exports, "getBackground", function () { return $f11b11c844963a32$export$18cb9425622d4e06; });
var $f11b11c844963a32$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});





parcelRegister("9aJr5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a62cd542d4ba6c4ac33816bbd6056646>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6ad84ad36817a302$var$_react = $6ad84ad36817a302$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6ad84ad36817a302$var$_information = $6ad84ad36817a302$var$_interopRequireDefault((parcelRequire("AQXRS")));

var $6ad84ad36817a302$var$_info = $6ad84ad36817a302$var$_interopRequireDefault((parcelRequire("gDTqd")));
function $6ad84ad36817a302$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6ad84ad36817a302$var$InformationIcon = (props)=>/*#__PURE__*/ $6ad84ad36817a302$var$_react.default.createElement($6ad84ad36817a302$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $6ad84ad36817a302$var$_info.default
    }, props));
$6ad84ad36817a302$var$InformationIcon.Name = "InformationIconMigration";
var $6ad84ad36817a302$var$_default = module.exports.default = $6ad84ad36817a302$var$InformationIcon;

});
parcelRegister("AQXRS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11503d00887c85dd37060e980bd5f02d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $06ec729375c8be79$var$_react = $06ec729375c8be79$var$_interopRequireDefault((parcelRequire("91i6m")));

var $06ec729375c8be79$var$_baseNew = $06ec729375c8be79$var$_interopRequireDefault((parcelRequire("aae9A")));
function $06ec729375c8be79$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $06ec729375c8be79$var$InformationIcon = (props)=>/*#__PURE__*/ $06ec729375c8be79$var$_react.default.createElement($06ec729375c8be79$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$06ec729375c8be79$var$InformationIcon.displayName = "InformationIcon";
var $06ec729375c8be79$var$_default = module.exports.default = $06ec729375c8be79$var$InformationIcon;

});

parcelRegister("gDTqd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c1db4778fe64f34b$var$_react = $c1db4778fe64f34b$var$_interopRequireDefault((parcelRequire("91i6m")));

var $el0Nf = parcelRequire("el0Nf");

var $c1db4778fe64f34b$var$_information = $c1db4778fe64f34b$var$_interopRequireDefault((parcelRequire("AQXRS")));
function $c1db4778fe64f34b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c1db4778fe64f34b$var$InfoIcon = (props)=>/*#__PURE__*/ $c1db4778fe64f34b$var$_react.default.createElement($el0Nf.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $c1db4778fe64f34b$var$_information.default
    }));
$c1db4778fe64f34b$var$InfoIcon.displayName = "InfoIcon";
var $c1db4778fe64f34b$var$_default = module.exports.default = $c1db4778fe64f34b$var$InfoIcon;

});


parcelRegister("kL1TI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::934663f3d49f13f5eb4d23bc2f11a666>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1c9ab411ed64618$var$_react = $f1c9ab411ed64618$var$_interopRequireDefault((parcelRequire("91i6m")));

var $f1c9ab411ed64618$var$_success = $f1c9ab411ed64618$var$_interopRequireDefault((parcelRequire("fHd6N")));

var $f1c9ab411ed64618$var$_checkCircle = $f1c9ab411ed64618$var$_interopRequireDefault((parcelRequire("bekx2")));
function $f1c9ab411ed64618$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f1c9ab411ed64618$var$SuccessIcon = (props)=>/*#__PURE__*/ $f1c9ab411ed64618$var$_react.default.createElement($f1c9ab411ed64618$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $f1c9ab411ed64618$var$_checkCircle.default
    }, props));
$f1c9ab411ed64618$var$SuccessIcon.Name = "SuccessIconMigration";
var $f1c9ab411ed64618$var$_default = module.exports.default = $f1c9ab411ed64618$var$SuccessIcon;

});
parcelRegister("fHd6N", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8a54e77ebc6c63c295a0cd7c7e0eeda>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b6d50a3f6bf24d5c$var$_react = $b6d50a3f6bf24d5c$var$_interopRequireDefault((parcelRequire("91i6m")));

var $b6d50a3f6bf24d5c$var$_baseNew = $b6d50a3f6bf24d5c$var$_interopRequireDefault((parcelRequire("aae9A")));
function $b6d50a3f6bf24d5c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b6d50a3f6bf24d5c$var$SuccessIcon = (props)=>/*#__PURE__*/ $b6d50a3f6bf24d5c$var$_react.default.createElement($b6d50a3f6bf24d5c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$b6d50a3f6bf24d5c$var$SuccessIcon.displayName = "SuccessIcon";
var $b6d50a3f6bf24d5c$var$_default = module.exports.default = $b6d50a3f6bf24d5c$var$SuccessIcon;

});

parcelRegister("bekx2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $82d0edbbec58accd$var$_react = $82d0edbbec58accd$var$_interopRequireDefault((parcelRequire("91i6m")));

var $el0Nf = parcelRequire("el0Nf");

var $82d0edbbec58accd$var$_success = $82d0edbbec58accd$var$_interopRequireDefault((parcelRequire("fHd6N")));
function $82d0edbbec58accd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $82d0edbbec58accd$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $82d0edbbec58accd$var$_react.default.createElement($el0Nf.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $82d0edbbec58accd$var$_success.default
    }));
$82d0edbbec58accd$var$CheckCircleIcon.displayName = "CheckCircleIcon";
var $82d0edbbec58accd$var$_default = module.exports.default = $82d0edbbec58accd$var$CheckCircleIcon;

});


parcelRegister("d8mmy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::783ce92761ea23bbb39745cb99e4a6be>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98fd5e7b488eb671$var$_react = $98fd5e7b488eb671$var$_interopRequireDefault((parcelRequire("91i6m")));

var $98fd5e7b488eb671$var$_warning = $98fd5e7b488eb671$var$_interopRequireDefault((parcelRequire("BOPYC")));

var $98fd5e7b488eb671$var$_warning2 = $98fd5e7b488eb671$var$_interopRequireDefault((parcelRequire("j0k6e")));
function $98fd5e7b488eb671$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for WarningIcon.
 * This component is WarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $98fd5e7b488eb671$var$WarningIcon = (props)=>/*#__PURE__*/ $98fd5e7b488eb671$var$_react.default.createElement($98fd5e7b488eb671$var$_warning.default, Object.assign({
        LEGACY_fallbackIcon: $98fd5e7b488eb671$var$_warning2.default
    }, props));
$98fd5e7b488eb671$var$WarningIcon.Name = "WarningIconMigration";
var $98fd5e7b488eb671$var$_default = module.exports.default = $98fd5e7b488eb671$var$WarningIcon;

});
parcelRegister("BOPYC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1447c2d9394cec1fac504fd0d225fa23>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $071ae40d5134056c$var$_react = $071ae40d5134056c$var$_interopRequireDefault((parcelRequire("91i6m")));

var $071ae40d5134056c$var$_baseNew = $071ae40d5134056c$var$_interopRequireDefault((parcelRequire("aae9A")));
function $071ae40d5134056c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $071ae40d5134056c$var$WarningIcon = (props)=>/*#__PURE__*/ $071ae40d5134056c$var$_react.default.createElement($071ae40d5134056c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.169c.757-1.396 2.76-1.396 3.516 0l5.9 10.878C16.381 13.379 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$071ae40d5134056c$var$WarningIcon.displayName = "WarningIcon";
var $071ae40d5134056c$var$_default = module.exports.default = $071ae40d5134056c$var$WarningIcon;

});

parcelRegister("j0k6e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dd5d9bbb61a3fdd4$var$_react = $dd5d9bbb61a3fdd4$var$_interopRequireDefault((parcelRequire("91i6m")));

var $el0Nf = parcelRequire("el0Nf");

var $dd5d9bbb61a3fdd4$var$_warning = $dd5d9bbb61a3fdd4$var$_interopRequireDefault((parcelRequire("BOPYC")));
function $dd5d9bbb61a3fdd4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dd5d9bbb61a3fdd4$var$WarningIcon = (props)=>/*#__PURE__*/ $dd5d9bbb61a3fdd4$var$_react.default.createElement($el0Nf.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $dd5d9bbb61a3fdd4$var$_warning.default
    }));
$dd5d9bbb61a3fdd4$var$WarningIcon.displayName = "WarningIcon";
var $dd5d9bbb61a3fdd4$var$_default = module.exports.default = $dd5d9bbb61a3fdd4$var$WarningIcon;

});






//# sourceMappingURL=MultiFactorPage.ccdab799.js.map
